import { Injectable, Query } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { CollectionsEntity } from "./collections.entity";
import { Entity, Repository, getManager } from "typeorm";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { ProductionLogRequest } from 'libs/shared-models/production-management/src/lib/production-inv/production-log.req';

import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import {  BrcReq, CollectionsFilters, DdbCollectionsReq, PaymentReq, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq, RodtepReportReq, SaleReq, ScriptGenReq, iceGateReq,RodteStatusReq, iceGateVerification, SaleReceiveReq, DutyDrawBackDateReq, DutyDrawBackReportReq, RmDateReq ,AgingReq, RmInvoiceDataForPayablesReq, RmPayblesReq} from "libs/shared-models/finance/src";
// import {  BrcReq, DdbCollectionsReq, PaymentReq, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq, , SaleReq, ScriptGenReq, iceGateReq } from "libs/shared-models/finance/src";
import {SoCustomerInvoice} from '../../../../sale-service/src/app/saleorder/customer-invoice.entity'
import {SaleOrderService} from '@gtpl/shared-services/sale-management'
import { BrcStatus, CollectionPaymentTypes, ContainerStatusEnum, IceGateStatus, ModeOfExportEnum, PayablePaymentStatusEnum, PaymentStatusEnum, RMTypePaybleEnum, RodtepStatus, SaleOrderStatusEnum, SoStatusEnum, StatusEnum, TransactionPaymentType, TransactionStatus, TransactionType } from "@gtpl/shared-models/common-models";
import {CollectionIdRequest, CollectionsReq, IgstCollectionsReq, IgstReportReq} from 'libs/shared-models/finance/src/lib/collections-req'
import { RodtepEntity } from "./rodtep.entity";
import { SoContainerStatusUpdate } from "@gtpl/shared-models/logistics";
// import { CollectionsFilters } from "@gtpl/shared-models/finance";
// import { CollectionsFilters } from "@gtpl/shared-models/finance";
import { Not } from 'typeorm';
import { PayableEntity } from "./payables.entity";
import {PayableFilterRequest, PayableRequest} from 'libs/shared-models/finance/src/lib/payable-request'
import { IdRequest } from "@gtpl/shared-models/gtpl";
import { PayablesDashboardReq } from "@gtpl/shared-models/raw-material-procurement";
let moment = require('moment');
moment().format();
@Injectable()
export class CollectionsService{
    constructor(
        @InjectRepository(CollectionsEntity)
        private repo: Repository<CollectionsEntity>,
        @InjectRepository(RodtepEntity)
        private rodtepRepo: Repository<RodtepEntity>,
        private soRepo: SaleOrderService
    ){}
    async getCollection(req:PaymentTypeReq):Promise<CommonResponse>{
        
        try{
            const manager = getManager()
            let query
            if(req.advance){
                query = `SELECT
si.po_number AS poNum,si.eda_date AS eta,si.act_edl_date AS etd,sum(soi.net_amount)as totalAmount,
b.bank_name AS bankName ,b.id AS bankId,s.sale_order_id as soId,
ec.end_customer_name AS buyer,ec.end_customer_id AS buyerId,
pt.payment_terms_name AS paymentTerms,pt.payment_terms_id AS paymentTermsId,
c.port_code AS PORT,c.cha,c.shipping_bill_date AS shippingBillDate,c.shipping_bill_no AS shippingBillNo,
si.processing_unit as unitId,ci.financial_year AS financialYear
FROM  ${appSettings.sales_db}.sale_order s 
LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =s.sale_order_id
LEFT JOIN  ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = si.end_customer_id
LEFT JOIN  ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
LEFT JOIN  ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
LEFT JOIN  ${appSettings.logistics_db}.container c ON c.sale_order_id =si.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON s.sale_order_id =soi.sale_order_id
LEFT JOIN  ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id =s.sale_order_id and ci.is_active=1
left join ${appSettings.finance_db}.collections co on s.sale_order_id = co.so_id and co.payment_type='${CollectionPaymentTypes.EXPORT_RECEIVABLES}' and co.advance_amt=0
WHERE 1=1 AND s.status!= '${SoStatusEnum.CANCELLED}'`
  if (req.unitId !== undefined) {
    query += ` AND ci.exporter_id = '${req.unitId}'`
  }

  query += ` GROUP BY si.sale_order_id`;
            }else{
                query = `SELECT ci.invoice_number as invoiceNumber,ci.total_amount, ci.collection,ci.sale_order_id as soId, DATE_FORMAT(ci.invoice_date, '%Y-%m-%d') AS invoiceDate,
            si.po_number as poNum,si.eda_date as eta,si.act_edl_date as etd,(SUM(soi.inv_amount)- COALESCE(ci.collection, 0)
    ) AS totalAmount,(SUM(soi.inv_amount)- COALESCE(ci.ddb_amt, 0)) AS ddbAmt,SUM(soi.inv_amount) AS invAmtUsd,
            b.bank_name as bankName ,b.id as bankId,ci.financial_year AS financialYear,
            ec.end_customer_name as buyer,ec.end_customer_id as buyerId,
            pt.payment_terms_name as paymentTerms,pt.payment_terms_id as paymentTermsId,
            c.port_code as port,c.cha,c.shipping_bill_date as shippingBillDate,c.shipping_bill_no as shippingBillNo,(ci.total_amount-ci.freight_charges)as fobValue,ci.exchange_rate AS exchangeRate,ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS tax,e.fda_due_date as dueDate,si.processing_unit as unitId
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = si.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN  ${appSettings.logistics_db}.container c ON c.sale_order_id =ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON s.sale_order_id =soi.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
            left join ${appSettings.logistics_db}.expenses e on e.sale_order_id = si.sale_order_id 
            WHERE 1=1 AND s.status!= '${SoStatusEnum.CANCELLED}' and ci.is_active=1`
            if(req.tab === CollectionPaymentTypes.EXPORT_RECEIVABLES){
               
                    query += ` AND c.status = 'SHIPPED' `
                
            }
            if(req.financeYear){
                query += ` AND ci.financial_year = '${req.financeYear}' `
            }
            if(req.tab === CollectionPaymentTypes.DUTY_DRAW_BACK){
                query += ` AND c.status = 'SHIPPED' AND (ci.ddb_amt = 0 or ci.ddb_amt is NULL) AND c.mode_of_export != '${ModeOfExportEnum.FLIGHT}' `
            }
            if(req.tab === CollectionPaymentTypes.IGST){
                query += ` AND c.status = 'SHIPPED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' AND (ci.igst_amt = 0 or ci.igst_amt is NULL)`
            }
            if(req.buyer !== undefined){
                query += ` AND si.end_customer_id = '${req.buyer}'`
            }
             if(req.unitId !== undefined){
                query += ` AND ci.exporter_id = '${req.unitId}'`
            }
            query += ` Group by si.sale_order_id`
            if(req.tab === CollectionPaymentTypes.EXPORT_RECEIVABLES){
               
                query += ` HAVING 
    (SUM(soi.inv_amount) - COALESCE(collection, 0) > 0 
    OR collection IS NULL) `
            
        }
        
        }
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    
    async generatePayment(req:CollectionsReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const entity = new CollectionsEntity()
                entity.bankCharges = req.bankCharges
                entity.buyerId = req.buyerId
                entity.bankId = req.bankId
                entity.buyerShortPayment = req.buyerShortPayment
                // entity.dueAmt = req.dueAmt
                entity.dueDate = req.dueDate?new Date(req.dueDate):null
                entity.eta = req.eta ? new Date(req.eta):null
                entity.etd = req.etd ? new Date(req.etd):null
                entity.invAmt = req.invAmt
                entity.invNum = req.invNum
                entity.paymentTermsId = req.paymentTermsId
                entity.poNum = req.poNum
                entity.recreceivedBankName  = req.receivedBankName
                // if(!req.advance){
                    // console.log(req.advance,'ppppppppp');
                    
                    entity.receivedAmtInr = req.receivedAmountInr
                    entity.recievedAmt = req.recievedAmt
                // }            
                entity.soId = req.soId
                entity.recievedDate = req.recievedDate ? new Date(req.recievedDate):null
                entity.transactionStatus = req.transactionStatus
                entity.transactionType = req.transactionType
                entity.remarks = req.remarks
                entity.createdUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = req.payment
                entity.exchangeRate = req.exchangeRate
                if(req.advance){
                    // console.log(req.advance,'trueeee');

                entity.advanceAmount = req.advanceAmount
                }
                // console.log(entity,'entityyyyyyy');
                
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                // console.log(save,'saveeeeeeeeeeee')
if(save){
    // console.log('uuuuuuuuuuuuuu');
    if(save.transactionStatus === TransactionStatus.CLOSE){
        const soStatusInSo: SoContainerStatusUpdate = {
            saleOrderId: req.soId,
            soStatus: SaleOrderStatusEnum.CLOSED
        }
        const closeSale = await this.soRepo.updateSoStatusForBl(soStatusInSo); 
        // console.log(closeSale,'ppppppppppppp');
        
    }
    const  exist = await this.soRepo.getCustInvoiceDetails({saleOrderId:req.soId})    
    // console.log(exist.data.collection,'ooooooooooooooooo');
    if(exist.status){

    
    const collectionAmt = Number(req.advance?req.advanceAmount:req.recievedAmt) + Number(req.buyerShortPayment?req.buyerShortPayment:0)+Number(exist.data.collection) +Number(req.bankCharges?req.bankCharges:0)
    const request = new PaymentReq()
    request.soId = req.soId
    request.collection = collectionAmt
    const update = await this.soRepo.updateColletion(request)
    
    if(update){
        saveFlag.add(true)
    }else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'Something went wrong ')
    }
}
}
            // const result = await manager.query(query)
            // if(result.length > 0){
            //     return new CommonResponse(true, 1,'Data retrieved successfully', result)
            // }else{
            //     return new CommonResponse(false, 0,'No data found',[])
            // }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong ')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong ',err)
        }
    }
    async generateDdbPayment(req:DdbCollectionsReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const entity = new CollectionsEntity()
                entity.shippingBillNo = req.shippingBillNo
                entity.buyerId = req.buyerId
                entity.shippingBillDate = req.shippingBillDate?new Date(req.shippingBillDate):null
                entity.invAmt = req.invAmt
                entity.invNum = req.invNum
                entity.recievedAmt = req.recievedAmt
                entity.soId = req.soId
                entity.recievedDate = req.recievedDate ? new Date(req.recievedDate):null
                entity.remarks = req.remarks
                entity.createdUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = req.payment
                entity.receivedAmtInr = req.receivedAmountInr
                entity.exchangeRate = req.exchangeRate
                entity.poNum =req.poNum
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                // console.log(save,'saveeeeeeeeeeee')
if(save){
    // console.log('uuuuuuuuuuuuuu');
    const  exist = await this.soRepo.getCustInvoiceDetails({saleOrderId:req.soId})    
    // console.log(exist.data.collection,'ooooooooooooooooo');
    const totalAmt = Number(req.receivedAmountInr) + Number(exist.data.ddbAmt)
    const request = new PaymentReq()
    request.soId = req.soId
    request.collection = totalAmt
    if(exist){
    const update = await this.soRepo.updateDdb(request)
    if(update){
        saveFlag.add(true)
    }else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'Something went wrong ')
    }
}else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'No invoice found')
}
}
            // const result = await manager.query(query)
            // if(result.length > 0){
            //     return new CommonResponse(true, 1,'Data retrieved successfully', result)
            // }else{
            //     return new CommonResponse(false, 0,'No data found',[])
            // }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in DDB Payment')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in DDB Payment',err)
        }
    }
    async getExportReceivablesData(req: CollectionsFilters): Promise<CommonResponse> {
        console.log(req, "--------------------")
        try {
            const manager = getManager()
            let tabquery = `SELECT  c.id, c.po_num as poNum, c.recieved_amt as recievedAmt, c.bank_charges as bankCharges, 
                 c.buyer_short_payment as buyerShortPayment, c.etd, c.eta, c.due_date as dueDate, c.received_date as recievedDate,
                 c.transaction_type as transactionType, c.transaction_status as transactionStatus, c.inv_num as invNum, 
                 c.inv_amt as invAmt, c.remarks,
                 ec.end_customer_name as endCustomerName, c.received_bank_name as bankName, 
                 pt.payment_terms_name as paymentTermsName, con.country_name as country, 
                 c.received_amt_inr as receivedAmountInr, c.exchange_rate as exchangeRate
                 FROM ${appSettings.finance_db}.collections c
                 LEFT JOIN ${appSettings.masters_db}.bank_details bd ON bd.id = c.bank_id
                 LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.buyer_id
                 LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = c.payment_terms_id
                 LEFT JOIN ${appSettings.masters_db}.countries con ON con.country_id = ec.country_id 
                 LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = c.so_id and ci.is_active=1
                 WHERE c.payment_type = "${CollectionPaymentTypes.EXPORT_RECEIVABLES}"`
    
            if (req.buyer) {
                tabquery += ` AND c.buyer_id = '${req.buyer}'`
            }
            if (req.invNo) {
                tabquery += ` AND c.inv_num = '${req.invNo}'`
            }
            if (req.unitId) {
                tabquery += ` AND ci.exporter_id = '${req.unitId}'`
            }
    
            const result = await manager.query(tabquery)
            
            if (result.length > 0) {
                const groupedData = {};
                
                result.forEach(row => {
                    const {
                        poNum, invNum, etd, eta, endCustomerName, country, paymentTermsName,
                        recievedAmt, bankCharges, buyerShortPayment, dueDate, recievedDate,
                        transactionType, transactionStatus, invAmt, remarks, bankName,
                        receivedAmountInr, exchangeRate, id
                    } = row;
                    
                    if (!groupedData[invNum]) {
                        groupedData[invNum] = {
                            poNum,
                            invNum,
                            etd,
                            eta,
                            endCustomerName,
                            country,
                            paymentTermsName,
                            transactions: []
                        };
                    }
                    
                    groupedData[invNum].transactions.push({
                        id,
                        recievedAmt,
                        bankCharges,
                        buyerShortPayment,
                        dueDate,
                        recievedDate,
                        transactionType,
                        transactionStatus,
                        invAmt,
                        remarks,
                        bankName,
                        receivedAmountInr,
                        exchangeRate
                    });
                });
                
                const responseData = Object.values(groupedData);
                
                return new CommonResponse(true, responseData.length, 'Data retrieved successfully', responseData);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw(err);
        }
    }
    async getDutyDrawBackData(req: CollectionsFilters): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let dutyquery = `SELECT
                co.shipping_bill_no as shippingBillNo, co.shipping_bill_date as shippingBillDate,
                co.cha, co.port_code as portCode,c.inv_num as invNum, c.inv_amt as invAmt,c.recieved_amt as recievedAmt,
                DATE(c.received_date) as receivedDate, c.scroll_no as scrollNo, DATE(c.scroll_date) as scrollDate, c.remarks,
                ec.end_customer_name as endCustomerName,con.country_name as country,c.received_amt_inr as receivedAmountInr,c.exchange_rate as exchangeRate,(ci.total_amount-ci.freight_charges) as fobvalue
                FROM ${appSettings.finance_db}.collections c
                LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = c.so_id 
                LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.buyer_id
                left join ${appSettings.masters_db}.countries con on con.country_id  = ec.country_id 
                left join ${appSettings.sales_db}.sale_order_items so on so.sale_order_id = c.so_id
                left join  ${appSettings.sales_db}.customer_invoice ci on ci.sale_order_id = c.so_id  and ci.is_active=1
                left join ${appSettings.sales_db}.sale_order s on s.sale_order_id = c.so_id 
                WHERE c.payment_type = "${CollectionPaymentTypes.DUTY_DRAW_BACK}" AND s.status != "${SoStatusEnum.CANCELLED}"
                `;
        
    
            if (req.buyer) {
                dutyquery += ` AND c.buyer_id = '${req.buyer}' `;
            }
            if (req.invNo) {
                dutyquery += ` AND c.inv_num = '${req.invNo}' `;
            }
            if (req.unitId) {
                dutyquery += ` AND ci.exporter_id = '${req.unitId}' `;
            }
    dutyquery += ` GROUP BY c.inv_num`
            const result2 = await manager.query(dutyquery);
            if (result2.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result2);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }

    async getRodtepData(req:CollectionsFilters):Promise<CommonResponse>{
        try{
            const manager= getManager();
            let rodtepQuerydata =` select 
                 co.shipping_bill_no as shippingBillNo, co.shipping_bill_date as shippingBillDate,
                 c.inv_num as invNum,sum(so.inv_amount) as invAmt,ec.end_customer_name as endCustomerName,
                 co.cha,co.leo_date,SUM(so.invoiced_qty) AS netweight,co.brc_rel_date as brcDate,
                 co.eta as leoDate,(ci.total_amount-ci.freight_charges)as fobvalue,ro.brc_val as brcValue,
                 ro.liscence_no as lisenceNo,ro.liscence_date as liscenceDate,c.recieved_amt as receivedAmt,c.po_num as poNumber,c.remarks,con.country_name as country,
                 ro.invoice_date as invoiceDate,ro.customer as customer,ro.sale_amount as saleAmount,ro.discount_rate as discountRate,ro.final_sale_amount as finalSaleAmount
                 
                 from ${appSettings.finance_db}.collections c
                 left join ${appSettings.logistics_db}.container co on co.sale_order_id = c.so_id 
                LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.buyer_id
                 left join ${appSettings.finance_db}.rodtep ro on ro.collection_id  = c.id
                 left join ${appSettings.sales_db}.sale_order_items so on so.sale_order_id = c.so_id
                 left join  ${appSettings.sales_db}.customer_invoice ci on ci.sale_order_id = c.so_id and ci.is_active=1
                 left join ${appSettings.masters_db}.countries con on con.country_id  = ec.country_id 
                 WHERE c.payment_type = "${CollectionPaymentTypes.RODTEP}"
                 group by c.so_id`
                 if (req.buyer) {
                    rodtepQuerydata += ` AND c.buyer_id = '${req.buyer}' `;
                }
                if (req.invNo) {
                    rodtepQuerydata += ` AND c.inv_num = '${req.invNo}' `;
                }
                const rodtepResult = await manager.query(rodtepQuerydata);
                if (rodtepResult.length > 0) {
                    return new CommonResponse(true, 1, 'Data retrieved successfully', rodtepResult);
                } else {
                    return new CommonResponse(false, 0, 'No data found', []);
                }
        }catch(err){
            throw err;
        }
    }
      
    
   async getBuyers(req:PaymentTypeReq):Promise<CommonResponse>{
        
        try{
            const manager = getManager()
            let query = `SELECT 
            ec.end_customer_name as buyer,ec.end_customer_id as buyerId
             FROM ${appSettings.sales_db}.customer_invoice ci
             LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            WHERE 1=1 and ci.is_active=1`
            if(req.tab === CollectionPaymentTypes.EXPORT_RECEIVABLES){
                query += ` AND ci.total_amount - ci.collection > 0 `
            }
            if(req.tab === CollectionPaymentTypes.DUTY_DRAW_BACK){
                query += ` AND ci.total_amount - ci.ddb_amt > 0 `
            }
            if(req.tab === CollectionPaymentTypes.IGST){
                query += ` AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST'`
            }
            query += ` GROUP BY ci.end_customer_id`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getReceivablesSummaryReport(req:ReceivablesSummaryReq):Promise<CommonResponse>{
        console.log(req,'ooooooooooooooooo');
        
        try{
            const manager = getManager()
            let query = `SELECT c.so_id ,so.country_id,co.country_name as country,SUM(c.recieved_amt) as total,
            SUM(CASE WHEN u.company = 'BMR INDUSTRIES PRIVATE LIMITED' THEN c.recieved_amt ELSE 0 END) AS bmrAmt,
            SUM(CASE WHEN u.company != 'BMR INDUSTRIES PRIVATE LIMITED' THEN c.recieved_amt ELSE 0 END) AS otherAmt
            FROM ${appSettings.finance_db}.collections c
           LEFT JOIN ${appSettings.sales_db}.so_invoice_details so ON so.sale_order_id = c.so_id
           LEFT JOIN ${appSettings.masters_db}.countries co ON co.country_id = so.country_id
           LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id = so.factoryId
           WHERE c.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'`
            if(req.fromDate != undefined){
                query +=` AND DATE(c.created_at) between '${req.fromDate}' and '${req.toDate}'`
            }

            query += ` GROUP BY co.country_name `
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getReceivablesDetailsReport(req:ReceivablesDetailsReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `
            SELECT c.invoice_number AS invoiceNum, c.total_amount AS totalAmount,c.eta_date AS eta,so.po_number AS poNum,
            so.bank_account_id,so.pay_terms_id,so.end_customer_id ,co.bl_no AS blNo,c.invoice_date AS invDate,
            ec.end_customer_name AS customerName,b.bank_name AS bank,p.payment_terms_name AS paymentTerm,co.etd as blDate,
            cl.recieved_amt AS paymentTerm,c.collection,cl.remarks,MAX(DATE(cl.received_date)) AS receivedDate
            FROM ${appSettings.sales_db}.customer_invoice c
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details so ON so.sale_order_id = c.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = so.bank_account_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = so.end_customer_id
            LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = so.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = so.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms p ON p.payment_terms_id = so.pay_terms_id
            WHERE YEAR(c.invoice_date)= '${req.year}' AND cl.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}' and c.is_active=1`
            query += `GROUP BY c.invoice_id`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    

    async getBuyerSDropDown():Promise<CommonResponse>{
    try{
        const manager=getManager()
        let query1 =`SELECT
        c.buyer_id as buyerId, ec. end_customer_name as buyerName
        FROM ${appSettings.finance_db}.collections c
        LEFT JOIN ${appSettings.masters_db}.end_customers ec ON  ec.end_customer_id  = c.buyer_id
        GROUP BY c.buyer_id `
        const result = await manager.query(query1)
        if(result.length > 0){
            return new CommonResponse(true, 1,'Data retrieved successfully', result)
        }else{
            return new CommonResponse(false, 0,'No data found',[])
        }

    }catch(err){
        throw(err)

    }
    
} 
async getInvoiceNumber():Promise<CommonResponse>{
    try{
        const manager =getManager()
        let query2 =`SELECT  c.inv_num as invNum 
        FROM ${appSettings.finance_db}.collections c
        GROUP BY c.inv_num`
        
        const result = await manager.query(query2)
        if(result.length>0){
            return new CommonResponse(true, 1,'Data retrieved successfully', result)
        }else{
            return new CommonResponse(false, 0,'No data found',[])
        }
    } catch(err){
        throw(err)
    }
}

    async getExpectedReceivablesReport():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let reportQuery =`select si. po_number as poNumber,  si.sale_order_id ,ci.invoice_number as invoiceNum,ci.invoice_date AS invoiceDate, ci.sale_order_id,si.eda_date as eta ,c.buyer_id ,
            ec. end_customer_name as partyName,ci.total_amount as invoiceAmt,SUM(c.received_amt_inr) as collection,pt. payment_terms_name as paymentTerms,
            bd.bank_name as bankName,e.fda_due_date as dueDate,ci.exchange_rate AS exchangeRate
            from ${appSettings.sales_db}.customer_invoice ci 
            left join ${appSettings.finance_db}.collections c on c.so_id =ci.sale_order_id and c.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'
            left join ${appSettings.sales_db}.so_invoice_details si on si.sale_order_id = ci.sale_order_id 
            left join ${appSettings.masters_db}.end_customers ec on ec.end_customer_id = si.end_customer_id
            left join ${appSettings.masters_db}.payment_terms pt on pt.payment_terms_id =c.payment_terms_id 
            left join ${appSettings.masters_db}.bank_details bd on bd.id =si.bank_account_id
            left join ${appSettings.logistics_db}.expenses e on e.sale_order_id = si.sale_order_id 
            left join ${appSettings.sales_db}.sale_order s on s.sale_order_id =ci.sale_order_id
            left join ${appSettings.logistics_db}.container co ON co.sale_order_id =ci.sale_order_id
            where (ci.total_amount - ci.collection)>0 AND co.status = '${ContainerStatusEnum.SHIPPED}' AND s.status !='${SaleOrderStatusEnum.CANCELLED}' and ci.is_active=1`
            reportQuery =reportQuery+=` GROUP BY ci.invoice_number`
            const result2 = await manager.query(reportQuery)
            if(result2.length>0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result2)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        
        }catch(err){
            throw(err)
        }
   
    }
    async getRodTepAbstractReport(req?:ProductionLogRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let rodtepQuery = `SELECT 
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status != 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' THEN received_amt_inr ELSE  
     CASE
        WHEN ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' 
        THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        )
        ELSE 0
      END  END) AS sum,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'SOLD' THEN received_amt_inr ELSE 0 END) AS rodtep_sold_sum,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SALE' THEN received_amt_inr ELSE 0 END) AS rodtep_ready_to_sell,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'RECEIVED' THEN received_amt_inr ELSE 0 END) AS PAYMENTRECEIVED,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SCRIPT GENERATION' THEN received_amt_inr ELSE 0 END) AS SCRIPT_GENERATION,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED' THEN  LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        )  ELSE 0 END) AS BRC_UPDATED,
     SUM(CASE WHEN payment_type = 'RODTEP' AND (ci.rodtep_status = 'READY FOR SCRIPT GENERATION' OR ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED') THEN (ci.total_amount-r.brc_val) ELSE 0 END) AS BALANCE_BRC_EEFC_AMOUNT,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND ICE GATE UPDATED' THEN received_amt_inr ELSE 0 END) AS PAYMENT_RECEIVED_SHOWN_IN_ICEGATE,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE UPDATED' THEN received_amt_inr ELSE 0 END) AS PAYMENTNOTRECEIVED_BUTSHOWIN_ICEGATE,
     SUM(CASE WHEN  ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        ) ELSE 0 END) AS PAYMENTNOTRECEIVED_BUT_NOTSHOWIN_ICEGATE,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status != 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE  
     CASE
        WHEN ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED'
        THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        )
        ELSE 0
      END  END) AS bmriplamount,
    
    
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'SOLD' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS rodtep_sold_sum_bmripl,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SALE'  AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED'THEN received_amt_inr ELSE 0 END) AS rodtep_ready_to_sell_bmripl,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'RECEIVED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENTRECEIVED_bmripl,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SCRIPT GENERATION'  AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED'THEN received_amt_inr ELSE 0 END) AS SCRIPT_GENERATION_bmripl,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED'THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        ) ELSE 0 END) AS BRC_UPDATED_bmripl,
     SUM(CASE WHEN payment_type = 'RODTEP' AND (ci.rodtep_status = 'READY FOR SCRIPT GENERATION' OR ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED') AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN (ci.total_amount-r.brc_val) ELSE 0 END) AS BALANCE_BRC_EEFC_AMOUNT_bmripl,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND ICE GATE UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENT_RECEIVED_SHOWN_IN_ICEGATE_bmripl,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENTNOTRECEIVED_BUTSHOWIN_ICEGATE_bmripl,
     SUM(CASE WHEN  ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        ) ELSE 0 END) AS PAYMENTNOTRECEIVED_BUT_NOTSHOWIN_ICEGATE_bmripl,
     
     
     SUM(CASE WHEN payment_type = 'RODTEP' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' AND ci.rodtep_status != 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' THEN received_amt_inr ELSE  CASE
        WHEN ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED'
        THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        )
        ELSE 0
      END  END) AS bmrexportamount,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'SOLD' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS rodtep_sold_sum_bmrexport,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SALE'  AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED'THEN received_amt_inr ELSE 0 END) AS rodtep_ready_to_sell_bmrexport,
    SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'RECEIVED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENTRECEIVED_bmrexport,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'READY FOR SCRIPT GENERATION'  AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED'THEN received_amt_inr ELSE 0 END) AS SCRIPT_GENERATION_bmrexport,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED'THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        ) ELSE 0 END) AS BRC_UPDATED_bmrexport,
     SUM(CASE WHEN payment_type = 'RODTEP' AND (ci.rodtep_status = 'READY FOR SCRIPT GENERATION' OR ci.rodtep_status = 'PAYMENT RECEIVED AND BRC UPDATED') AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN (ci.total_amount-r.brc_val) ELSE 0 END) AS BALANCE_BRC_EEFC_AMOUNT_bmrexport,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT RECEIVED AND ICE GATE UPDATED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENT_RECEIVED_SHOWN_IN_ICEGATE_bmrexport,
     SUM(CASE WHEN payment_type = 'RODTEP' AND ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE UPDATED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN received_amt_inr ELSE 0 END) AS PAYMENTNOTRECEIVED_BUTSHOWIN_ICEGATE_bmrexport,
     SUM(CASE WHEN  ci.rodtep_status = 'PAYMENT NOT RECEIVED AND ICE GATE NOT UPDATED' AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN LEAST(
          0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
          42 * (
            CASE
              WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ')
              THEN soi.invoiced_qty * 0.454
              ELSE soi.invoiced_qty
            END
          )
        ) ELSE 0 END) AS PAYMENTNOTRECEIVED_BUT_NOTSHOWIN_ICEGATE_bmrexport

FROM ${appSettings.sales_db}.customer_invoice  ci
LEFT JOIN ${appSettings.finance_db}.collections co ON ci.sale_order_id = co.so_id
left join ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id = co.unit_id
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
  LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
  left join ${appSettings.finance_db}.rodtep r on r.collection_id = co.id
where 1=1 AND  container_status = 'SHIPPED'
 AND so_status != 'CANCELLED' and ci.is_active=1
`
if(req.fromDate && req.toDate){
    rodtepQuery=rodtepQuery+' And DATE(co.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"';
}
     const redtepresult = await manager.query(rodtepQuery)
     if(redtepresult.length>0){
        return new CommonResponse(true,1,'Data retrived sucessfully',redtepresult)
     }else{
        return new CommonResponse(false,0,'No data dound',[])
     }
        }catch(err){
            throw(err)
        }
    }



    async getShippedPoData(req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT ci.invoice_number AS invoiceNumber,ci.total_amount as invAmt, ci.collection,ci.sale_order_id AS soId,
            si.po_number AS poNum,si.eda_date AS eta,si.act_edl_date AS etd,ci.total_amount - ci.collection AS totalAmount,ci.total_amount - ci.ddb_amt AS ddbAmt,ci.financial_year as financeYear,
            b.bank_name AS bankName ,b.id AS bankId,
            ec.end_customer_name AS buyer,ec.end_customer_id AS buyerId,
            pt.payment_terms_name AS paymentTerms,pt.payment_terms_id AS paymentTermsId,c.cha as cha,
            c.port_code AS port,c.cha,c.shipping_bill_date AS shippingBillDate,c.shipping_bill_no AS shippingBillNo,SUM(so.invoiced_qty) ,(ci.total_amount-ci.freight_charges) AS fob,co.ice_gate_status AS iceGateStatus,ci.exchange_rate AS exchangeRate,si.processing_unit as unitId,
            sum( CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN so.invoiced_qty *0.454 ELSE so.invoiced_qty END) AS qty
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id = ci.sale_order_id 
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.collections co ON co.so_id = s.sale_order_id  AND co.ice_gate_status !="${IceGateStatus.UPDATE}" AND co.ice_gate_status IS NOT NULL
            LEFT JOIN ${appSettings.sales_db}.sale_order_items so ON so.sale_order_id = ci.sale_order_id
              LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = so.uom_id
            WHERE c.status = '${ContainerStatusEnum.SHIPPED}' AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}' OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1`
            if(req.financeYear ){
                query += ` AND ci.financial_year = '${req.financeYear}' `
            }
             if(req.unitId ){
                query += ` AND ci.exporter_id = '${req.unitId}' `
            }
            query += ` GROUP BY si.sale_order_id`
            const result = await manager.query(query)
            let querry1 = ``
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async iceGateUpdate(req:iceGateReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const exist  = await transactionManager.getRepository(CollectionsEntity).findOne({where:{paymentType:CollectionPaymentTypes.RODTEP,soId:req.soId}})
            if(exist){
                const entity = new CollectionsEntity()
                entity.scrollNo = req.scrollNo
                entity.buyerId = req.buyerId
                entity.scrollDate = req.scrollDate?new Date(req.scrollDate):null
                entity.invNum = req.invNum
                entity.receivedAmtInr = req.recievedAmt
                entity.soId = req.soId
                entity.updatedUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = req.payment
                entity.eta = req.eta?new Date(req.eta):null
                entity.poNum = req.poNum
                entity.iceGateStatus = IceGateStatus.UPDATE
                entity.shippingBillNo = req.shippingBillNo
                entity.shippingBillDate = req.shippingBillDate?new Date(req.shippingBillDate):null

            const update = await transactionManager.getRepository(CollectionsEntity).update({id:exist.id},entity)
            if(update){
                const existExport  = await transactionManager.getRepository(CollectionsEntity).findOne({where:{paymentType:CollectionPaymentTypes.EXPORT_RECEIVABLES,soId:req.soId}})
            if(existExport){
                console.log(existExport,'ppppppppp');
                
                const req = new RodteStatusReq(existExport.soId,
                    existExport.transactionType == TransactionPaymentType.Full_Payment? 
                    existExport.transactionType == TransactionPaymentType.Full_Payment && exist.BrcStatus == BrcStatus.FULL_UPDATE?
                    RodtepStatus.READY_FOR_SCRIPT_GENERATION:RodtepStatus.PAYMENT_RECEIVED_AND_ICE_GATE_UPDATED: RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_UPDATED)
                    const invoice = await this.soRepo.updateRodtepStatus(req)
                    if(invoice){
                        saveFlag.add(true)
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
            }
            else{
                const request = new RodteStatusReq(req.soId, exist.BrcStatus==BrcStatus.FULL_UPDATE?RodtepStatus.READY_FOR_SCRIPT_GENERATION:RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_UPDATED)
                    const invoice = await this.soRepo.updateRodtepStatus(request)
                    if(invoice){
                        saveFlag.add(true)
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
            }
                saveFlag.add(true)
            }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong ')
            }
            
            }else{
                const entity = new CollectionsEntity()
                entity.scrollNo = req.scrollNo
                entity.buyerId = req.buyerId
                entity.scrollDate = req.scrollDate?new Date(req.scrollDate):null
                entity.invNum = req.invNum
                entity.receivedAmtInr = req.recievedAmt
                entity.soId = req.soId
                entity.createdUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = req.payment
                entity.eta = req.eta?new Date(req.eta):null
                entity.poNum = req.poNum
                entity.paymentType = CollectionPaymentTypes.RODTEP
                entity.iceGateStatus = IceGateStatus.UPDATE
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                console.log(save,'saveeeeeeeee');
                // if(save){

                // }
                if(save){
                    const existExport  = await transactionManager.getRepository(CollectionsEntity).findOne({where:{paymentType:CollectionPaymentTypes.EXPORT_RECEIVABLES,soId:req.soId}})
                    if(existExport){
                    const req = new RodteStatusReq(save.soId,existExport.transactionType == TransactionPaymentType.Full_Payment && existExport?RodtepStatus.PAYMENT_RECEIVED_AND_ICE_GATE_UPDATED:RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_UPDATED)
                     const invoice = await this.soRepo.updateRodtepStatus(req)
                     if(invoice){
                        saveFlag.add(true)
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
                
            }
            else{
                const req = new RodteStatusReq(save.soId,RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_UPDATED)
                const invoice = await this.soRepo.updateRodtepStatus(req)
                if(invoice){
                   saveFlag.add(true)
               }else{
               saveFlag.add(false)
               await transactionManager.releaseTransaction()
               return new CommonResponse(false,0,'Something went wrong ')
               }
            }
            }
        }
           
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in ice gate update')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in ice gate update',err)
        }
    }
    async getBrcPoData(req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT ci.invoice_number AS invoiceNumber,ci.total_amount as invAmt, ci.collection,ci.sale_order_id AS soId, si.po_number AS poNum,si.eda_date AS eta,si.act_edl_date AS etd,ci.total_amount - ci.collection AS totalAmount,ci.total_amount - ci.ddb_amt AS ddbAmt,SUM(so.invoiced_qty) AS qty,ci.financial_year as financeYear,
            b.bank_name AS bankName ,b.id AS bankId,co.scroll_date as scrollDate, co.scroll_no as scrollNo,
            ec.end_customer_name AS buyer,ec.end_customer_id AS buyerId,
            pt.payment_terms_name AS paymentTerms,pt.payment_terms_id AS paymentTermsId,c.cha as cha,
            c.port_code AS port,c.cha,c.shipping_bill_date AS shippingBillDate,c.shipping_bill_no AS shippingBillNo,(CASE WHEN co.payment_type = 'RODTEP' THEN  co.received_amt_inr ELSE 0 END)  as rodtep,(SELECT COUNT(*) 
            FROM ${appSettings.finance_db}.collections co_sub 
            WHERE co_sub.so_id = s.sale_order_id AND co_sub.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}') AS exportReceivablesCount,
          (SELECT COUNT(*)  
            FROM ${appSettings.finance_db}.rodtep co_sub
            LEFT JOIN ${appSettings.finance_db}.collections c ON c.id = co_sub.collection_id
            WHERE c.so_id = s.sale_order_id AND c.payment_type = '${CollectionPaymentTypes.RODTEP}') AS rodtepCount,(ci.total_amount-ci.freight_charges) AS fob,si.processing_unit as unitId
       
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.collections co ON co.so_id = s.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items so ON so.sale_order_id = ci.sale_order_id
            where 1=1 and co.brc_status != '${BrcStatus.FULL_UPDATE}'and ci.is_active=1 AND (co.payment_type = '${CollectionPaymentTypes.RODTEP}'  
            OR (co.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}' AND transaction_status = '${TransactionStatus.CLOSE}' AND NOT EXISTS (
        SELECT 1
        FROM ${appSettings.finance_db}.collections c2
        WHERE c2.so_id = ci.sale_order_id
          AND c2.payment_type = '${CollectionPaymentTypes.RODTEP}'
      ))) `
            // co.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'
            // AND transaction_status ='${TransactionStatus.CLOSE}'  `
            //  AND co.ice_gate_status = '${IceGateStatus.UPDATE}' and  co.payment_type = '${CollectionPaymentTypes.RODTEP}'`
            if(req.financeYear){
                query += ` AND ci.financial_year = '${req.financeYear}' `
            }
             if(req.unitId){
                query += ` AND ci.exporter_id = '${req.unitId}' `
            }
            query += `GROUP BY si.sale_order_id`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async brcUpdate(req:BrcReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            console.log(req,'brccccccccc');
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const exist  = await transactionManager.getRepository(CollectionsEntity).findOne({where:{paymentType:CollectionPaymentTypes.RODTEP,soId:req.soId}})
            if(exist){
                const entity = new RodtepEntity()
                entity.brcNum = req.brcNo
                entity.brcDate = req.brcDate?new Date(req.brcDate):null
                entity.brcVal = req.brcVal
                entity.irmnNum = req.irmnNo
                const collection = new CollectionsEntity()
                collection.id = exist.id
                entity.collectionInfo = collection  
                entity.createdUser = req.createdUser              
                const save = await transactionManager.getRepository(RodtepEntity).save(entity)
            // console.log(save,'saveeeeeeeee');
// console.log(Number(req.exportCount-1) === Number(req.rodtepCount)?BrcStatus.FULL_UPDATE:BrcStatus.PARTIAL_UPDATE,'pppppppppppp');

                if(save){
                    const existExports  = await transactionManager.getRepository(CollectionsEntity).find({where:{soId:req.soId}})
                    if(existExports.length>0){
                        for(const val of existExports ){
                        const update = await transactionManager.getRepository(CollectionsEntity).update({id:val.id},{BrcStatus:BrcStatus.FULL_UPDATE})
                                console.log(update,'updateee');
                                if(update.affected){
                                    saveFlag.add(true)
                                }else{
                                saveFlag.add(false)
                                await transactionManager.releaseTransaction()
                                return new CommonResponse(false,0,'Something went wrong ')
                                }
                    }
                    }
                     const update = await transactionManager.getRepository(CollectionsEntity).update({id:exist.id},{BrcStatus:BrcStatus.FULL_UPDATE})
            console.log(update,'updateee');

                    if(update){
            //             let rodtepCount = `SELECT COUNT(*) as count 
            // FROM ${appSettings.finance_db}.rodtep co_sub
            // LEFT JOIN collections c ON c.id = co_sub.collection_id
            // WHERE c.so_id = ${req.soId} AND c.payment_type = '${CollectionPaymentTypes.RODTEP}'`
            // let exportCount = `SELECT COUNT(*) as count  
            // FROM ${appSettings.finance_db}.collections co_sub 
            // WHERE co_sub.so_id = ${req.soId} AND co_sub.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'`
            // const exportCountResult = await manager.query(exportCount)
            // const rodtepCountResult = await manager.query(rodtepCount)
                    //    console.log(Number(exportCountResult[0]?.count) === Number(rodtepCountResult[0].count),'count');
                    //    console.log(exist.iceGateStatus,'ice gate status');
                    //  console.log(Number(exportCountResult[0]?.count),Number(rodtepCountResult[0]?.count),'export','rodtep');
                     
                    const request = new RodteStatusReq(exist.soId,
                         exist.iceGateStatus === IceGateStatus.UPDATE?
                        RodtepStatus.READY_FOR_SCRIPT_GENERATION
                        :RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED)
                        // console.log(request,'pppppppp');
                       const invoice = await this.soRepo.updateRodtepStatus(request)
                    // let invoice 
                    // console.log(invoice,'iiiiiiiiiiiii');
                    
                 if(invoice){
                    saveFlag.add(true)
                }else{
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong ')
                }
                        saveFlag.add(true)
                        console.log(update,'updateeeeee');
                        
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
                }
                else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
            }else{
                // console.log('not existttttttt');
                const existExports  = await transactionManager.getRepository(CollectionsEntity).find({where:{soId:req.soId}})
if(existExports.length>0){
    for(const val of existExports ){
    const update = await transactionManager.getRepository(CollectionsEntity).update({id:val.id},{BrcStatus:BrcStatus.FULL_UPDATE})
            console.log(update,'updateee');
            if(update.affected){
                saveFlag.add(true)
            }else{
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong ')
            }
}
}
                const entity = new CollectionsEntity()
                entity.scrollNo = req.scrollNo
                entity.buyerId = req.buyerId
                entity.scrollDate = req.scrollDate?new Date(req.scrollDate):null
                entity.invNum = req.invNum
                entity.recievedAmt = req.recievedAmt
                entity.soId = req.soId
                entity.createdUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = CollectionPaymentTypes.RODTEP
                entity.eta = req.eta?new Date(req.eta):null
                entity.poNum = req.poNum
                entity.BrcStatus = BrcStatus.FULL_UPDATE

                // console.log(Number(req.exportCount-1) === Number(req.rodtepCount)?BrcStatus.FULL_UPDATE:BrcStatus.PARTIAL_UPDATE,'pppppppppppp');

                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
               if(save){
                // console.log(save,'saveeeeeeeeeeee');
                
                const entity = new RodtepEntity()
                entity.brcNum = req.brcNo
                entity.brcDate = req.brcDate?new Date(req.brcDate):null
                entity.brcVal = req.brcVal
                entity.irmnNum = req.irmnNo
                const collection = new CollectionsEntity()
                collection.id = save.id
                entity.collectionInfo = collection
                entity.createdUser = req.createdUser
                // console.log(entity,'oooooooooooooooooooo');
                
                const saveRodtep = await transactionManager.getRepository(RodtepEntity).save(entity)

                if(saveRodtep){
                    let rodtepCount = `SELECT COUNT(*) as count 
            FROM ${appSettings.finance_db}.rodtep co_sub
            LEFT JOIN collections c ON c.id = co_sub.collection_id
            WHERE c.so_id = ${req.soId} AND c.payment_type = '${CollectionPaymentTypes.RODTEP}'`
            let exportCount = `SELECT COUNT(*) as count 
            FROM ${appSettings.finance_db}.collections co_sub 
            WHERE co_sub.so_id = ${req.soId} AND co_sub.payment_type = '${CollectionPaymentTypes.EXPORT_RECEIVABLES}'`
            const exportCountResult = await manager.query(exportCount)
            const rodtepCountResult = await manager.query(rodtepCount)
            // console.log(Number(exportCountResult[0]?.count) === Number(rodtepCountResult[0].count),'count');
            //            console.log(save.iceGateStatus,'ice gate status');
            //          console.log(Number(exportCountResult[0]?.count),Number(rodtepCountResult[0]?.count),'export','rodtep');
                     const request = new RodteStatusReq(req.soId,save.iceGateStatus === IceGateStatus.VERIFIED?
                       RodtepStatus.READY_FOR_SCRIPT_GENERATION
                       :RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED)
                        // console.log(request,'reqqqqqqqqqqqqq');
                        
                        // let invoice
                        const invoice = await this.soRepo.updateRodtepStatus(request)
                    saveFlag.add(true)
                    if(invoice){
                        saveFlag.add(true)
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }

                }else{
                // console.log('no rooooooooooooooo');

                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong ')
                }
                   }
            }
     
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in brc update')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in brc update',err)
        }
    }
    async getScriptGenPoData(req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT ci.invoice_number AS invoiceNumber,ci.total_amount as invAmt, ci.collection,ci.sale_order_id AS soId,co.id as collectionId,ci.financial_year as financeYear,
            si.po_number AS poNum,si.eda_date AS eta,si.act_edl_date AS etd,ci.total_amount - ci.collection AS totalAmount,ci.total_amount - ci.ddb_amt AS ddbAmt,
            b.bank_name AS bankName ,b.id AS bankId,co.scroll_date as scrollDate, co.scroll_no as scrollNo,
            ec.end_customer_name AS buyer,ec.end_customer_id AS buyerId,
            pt.payment_terms_name AS paymentTerms,pt.payment_terms_id AS paymentTermsId,c.cha as cha,
            c.port_code AS port,c.cha,c.shipping_bill_date AS shippingBillDate,c.shipping_bill_no AS shippingBillNo,co.received_amt_inr as rodtep,co.id as collectionId,SUM(r.brc_val) AS brcVal ,SUM(CASE WHEN co.payment_type = '${CollectionPaymentTypes.RODTEP}' THEN co.recieved_amt ELSE 0 END) AS rodtepAmt,(ci.total_amount-ci.freight_charges) AS fob,SUM(so.invoiced_qty) AS qty
            FROM ${appSettings.finance_db}.collections co
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =co.so_id
            LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = s.sale_order_id  and ci.is_active =1
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =co.so_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = co.so_id
             LEFT JOIN ${appSettings.sales_db}.sale_order_items so ON so.sale_order_id =ci.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.rodtep r ON r.collection_id = co.id
            WHERE ci.rodtep_status = '${RodtepStatus.READY_FOR_SCRIPT_GENERATION}' and co.payment_type = '${CollectionPaymentTypes.RODTEP}'`
            //  AND co.ice_gate_status = '${IceGateStatus.UPDATE}' and  co.brc_status = '${BrcStatus.FULL_UPDATE}'`
            if(req.financeYear ){
                query += ` AND ci.financial_year = '${req.financeYear}' `
            }
             if(req.unitId ){
                query += ` AND ci.exporter_id = '${req.unitId}' `
            }
            query += `GROUP BY co.inv_num`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async getBrcInfo(req:CollectionIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT r.irmn_num AS irmnNo, r.brc_num AS brcNo ,r.brc_val AS brcVal,r.brc_date AS brcDate,r.collection_id AS collectionId FROM rodtep r WHERE r.collection_id = ${req.collectionId}`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async createScriptGeneration(req:ScriptGenReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            for (const request of req.brcInfo){
                const find = await transactionManager.getRepository(RodtepEntity).find({where:{collectionInfo:{id:request.collectionId}}})
                if(find.length>0){
                    for(const val of find){
                        const entity = new RodtepEntity()
                        entity.liscenceDate = req.liscenceDate?new Date(req.liscenceDate):null
                        entity.liscenceNum = req.liscenceNo
                        const save = await transactionManager.getRepository(RodtepEntity).update({id:val.id},{
                            liscenceDate:req.liscenceDate?new Date(req.liscenceDate):null,
                            liscenceNum:req.liscenceNo
                        })
                if(save){
                    const so = await transactionManager.getRepository(CollectionsEntity).findOne({where:{id:request.collectionId}})
                    const req = new RodteStatusReq(so.soId,
                        RodtepStatus.READY_FOR_SALE)
                    const invoice = await this.soRepo.updateRodtepStatus(req)
                        if(invoice){
                    saveFlag.add(true)
                }else{
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong ')
                }
                        saveFlag.add(true)
                        // console.log(update,'updateeeeee');
                        
                    }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    }
            //         const invoice = await transactionManager.getRepository(SoCustomerInvoice).update({saleOrderId:so.id},{RodtepStatus:RodtepStatus.READY_FOR_SALE})
            //     if(invoice){
            //     saveFlag.add(true)
            // }else{
            // saveFlag.add(false)
            // await transactionManager.releaseTransaction()
            // return new CommonResponse(false,0,'Something went wrong ')
            // }
                    // const update = await transactionManager.getRepository(CollectionsEntity).update({id:request.collectionId},{RodtepStatus: RodtepStatus.READY_FOR_SALE})
                    // if(update){
                    //     saveFlag.add(true)
                    // }else{
                    // saveFlag.add(false)
                    // await transactionManager.releaseTransaction()
                    // return new CommonResponse(false,0,'Something went wrong ')
                    // }
                // else{
                //     saveFlag.add(false)
                //     await transactionManager.releaseTransaction()
                //     return new CommonResponse(false,0,'Something went wrong ')
                // }
                    }
                    
                } else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'No records found')
                    
                }
            }
            
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in brc update')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in brc update',err)
        }
    }
    async getLicsenseInfo(req:CollectionIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT ci.invoice_number AS invoiceNumber,ci.total_amount as invAmt, ci.collection,ci.sale_order_id AS soId,
            si.po_number AS poNum,si.eda_date AS eta,si.act_edl_date AS etd,ci.total_amount - ci.collection AS totalAmount,ci.total_amount - ci.ddb_amt AS ddbAmt,
            b.bank_name AS bankName ,b.id AS bankId,co.scroll_date as scrollDate , co.scroll_no as scrollNo,
            ec.end_customer_name AS buyer,ec.end_customer_id AS buyerId,
            pt.payment_terms_name AS paymentTerms,pt.payment_terms_id AS paymentTermsId,c.cha as cha,
            c.port_code AS port,c.cha,c.shipping_bill_date AS shippingBillDate,c.shipping_bill_no AS shippingBillNo,co.received_amt_inr as rodtep,co.id as collectionId,SUM(so.invoiced_qty) AS qty,(ci.total_amount-ci.freight_charges) AS fob,((ci.total_amount-ci.freight_charges)*ci.exchange_rate) AS fobValueInr,ci.exchange_rate as exchangeRate,r.brc_num AS brcNo ,r.brc_date AS brcDate,
            r.brc_val AS brcRealisedValue
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details si ON si.sale_order_id =ci.sale_order_id 
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id = si.pay_terms_id
            LEFT JOIN ${appSettings.masters_db}.bank_details b ON b.id = si.bank_account_id
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.collections co ON co.so_id = s.sale_order_id
            LEFT JOIN ${appSettings.finance_db}.rodtep r ON r.collection_id = co.id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items so ON so.sale_order_id =ci.sale_order_id
            WHERE r.liscence_no = '${req.liscenceNum}' and ci.is_active=1 `
            query += `GROUP BY si.sale_order_id`

            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    async createSale(req:SaleReq):Promise<CommonResponse>{
        console.log(req,'llllllllllll');
        
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            for (const request of req.liscenceInfo){
                const find = await transactionManager.getRepository(RodtepEntity).find({where:{liscenceNum:request.liscenceNo},relations:['collectionInfo']})
                if(find.length>0){
                   let index = 0
                    for(const val of find){
                        console.log(index,'85455');
                        console.log(req,'85455');

                        
                        const entity = new RodtepEntity()
                        entity.discountRate =  req.discountRate
                        entity.saleAmt = req.saleAmount
                        entity.finalSaleAmt = req.finalSaleAmount
                        entity.invoiceDate = req.invoiceDate?new Date(req.invoiceDate):null
                        entity.invoiceNum = req.invoiceNo
                        entity.customer = req.customer
                        entity.createdUser= req.createdUser
                        const save = await transactionManager.getRepository(RodtepEntity).update({liscenceNum:request.liscenceNo},entity)

                if(save){
                    const so = await transactionManager.getRepository(CollectionsEntity).findOne({where:{id:val.collectionInfo.id}})
                    const req = new RodteStatusReq(so.soId,
                        RodtepStatus.SOLD)
                    const invoice = await this.soRepo.updateRodtepStatus(req)
                        if(invoice){
                    saveFlag.add(true)
                }else{
                saveFlag.add(false)
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong ')
                }
                    // const update = await transactionManager.getRepository(CollectionsEntity).update({id:val.collectionInfo.id},{RodtepStatus:RodtepStatus.SOLD})
                    // if(update){
                    //     saveFlag.add(true)
                    //     console.log(update,'updateeeeee');
                        
                    // }else{
                    // saveFlag.add(false)
                    // await transactionManager.releaseTransaction()
                    // return new CommonResponse(false,0,'Something went wrong ')
                    // }
                    index = index + 1
                    saveFlag.add(true)
                }else{
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong ')
                    
                }
                    }
                }
            }
          
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in brc update')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in brc update',err)
        }
    }
    async getSalePoData():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = ` SELECT r.liscence_no AS liscenceNum ,r.liscence_date AS liscenceDate,SUM(co.recieved_amt) AS amountAsPerIceGate,
            SUM(r.brc_val) AS brcValue,
            con.port_code as portCode,r.collection_id AS collectionId,(
                SELECT SUM(dlc.received_amt_inr)
                FROM  (SELECT DISTINCT
                (
                r_inner.collection_id ) AS collection_id,
                r_inner.liscence_no,
                co_inner.received_amt_inr
            FROM
                ${appSettings.finance_db}.rodtep r_inner
            LEFT JOIN
                ${appSettings.finance_db}.collections co_inner ON co_inner.id = r_inner.collection_id AND co_inner.payment_type = 'RODTEP')  AS dlc
                WHERE dlc.liscence_no = r.liscence_no
            )AS liscenceAmt FROM rodtep r
            LEFT JOIN ${appSettings.finance_db}.collections co ON co.id = r.collection_id
            LEFT JOIN ${appSettings.logistics_db}.container con ON con.sale_order_id = co.so_id 
            LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = co.so_id and ci.is_active=1
            WHERE ci.rodtep_status = '${RodtepStatus.READY_FOR_SALE}'
             GROUP BY r.liscence_no`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
        
    }
 async getRodtepReportWithCollections(req: RodtepReportReq): Promise<CommonResponse> {
        console.log(req, "reqqqqqqqqqqqqqqqqqqq");
        try {
            const manager = getManager();
            let query = `
                SELECT 
                    ro.collection_id,
                    ro.brc_num AS brcNum,
                    ro.brc_val AS brcValue,
                    ro.id,
                    ro.irmn_num AS irmNum,
                    ro.brc_date AS brcDate,
                    ro.liscence_no as liscenceNo,
                    ro.liscence_date as liscenceDate,
                    ro.invoice_number as invoiceId,
                    ro.invoice_date as invoiceDate,
                    col.inv_num as invNum, 
                    col.inv_amt as invAmount,
                    col.buyer_id,
                    col.so_id,
                    col.id,
                    col.unit_id,
                    SUM(col.received_amt_inr) AS amountAsPerIceGate,
                    DATE(col.created_at) AS createdAt,
                    ec.end_customer_name as buyerName,
                    ci.rodtep_status as rodtepStatus,
                    ci.port_of_loading as portOfLoading,
                    ci.total_amount AS totalAmount,
                    ci.freight_charges AS freightCharges,
                    con.shipping_bill_no AS shippingNum,
                    con.shipping_bill_date AS shippingDate,
                    con.cha,
                    con.leo_date AS leoDate,
                    con.brc_rel_date AS brcRelDate,soi.net_weight AS netWeight,
                    uc.unit_name AS unitName,uc.company,uc.unit_code_id
                FROM 
                    ${appSettings.finance_db}.rodtep ro
                    LEFT JOIN ${appSettings.finance_db}.collections col ON col.id = ro.collection_id
                    LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = col.buyer_id
                    LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = col.so_id and ci.is_active=1
                    LEFT JOIN ${appSettings.logistics_db}.container con ON con.sale_order_id = col.so_id
                    LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id=col.so_id
                    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=col.unit_id

                WHERE 1 = 1`;
    
            if (req.fromDate != undefined && req.toDate != undefined) {
                query += ` AND DATE(col.created_at) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            if(req.company){
                query += ` and ci.exporter_id = '${req.company}'`
              }
              if(req.unitId> 0 && req.unitId!=5){
                query += ` and ci.unit_id = ${req.unitId}`
              }
    
            query += ` GROUP BY ro.collection_id`;
    
            const result = await manager.query(query);
            console.log(result, "resulttttttttttt666666666666666666667777777777");
    
            if (result.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw (err);
        }
    }

    async iceGateVerification(req:iceGateVerification):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const exist  = await transactionManager.getRepository(CollectionsEntity).findOne({where:{paymentType:CollectionPaymentTypes.RODTEP,soId:req.soId}})
            if(exist){
                
                const entity = new CollectionsEntity()
                entity.poNum = req.poNum
                entity.invNum = req.invNum
                entity.soId = req.soId
                entity.buyerId = req.buyerId
                entity.invAmt =req.invAmt
                entity.unitId = req.unitId
               entity.iceGateStatus = req.status    
            const update = await transactionManager.getRepository(CollectionsEntity).update({id:exist.id},entity)
            // if(update){
            
            //     saveFlag.add(true)
            // }else{
            // saveFlag.add(false)
            // await transactionManager.releaseTransaction()
            // return new CommonResponse(false,0,'Something went wrong ')
            // }
            if(update.affected>0){
                const existExport  = await transactionManager.getRepository(CollectionsEntity).find({where:{soId:req.soId}})
            if(existExport.length>0){
                for(const val of existExport){
                    const existExportIceGate = await transactionManager.getRepository(CollectionsEntity).update({id:val.id},entity)
                        if(existExportIceGate){
                            saveFlag.add(true)
                        }else{
                        saveFlag.add(false)
                        await transactionManager.releaseTransaction()
                        return new CommonResponse(false,0,'Something went wrong ')
                        }

                }
            }
            saveFlag.add(true)
            

            }else{
                
            saveFlag.add(false)
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong ')
            }
            }else{
                
                const entity = new CollectionsEntity()
               entity.invNum = req.invNum
               entity.poNum = req.poNum
               entity.soId = req.soId
               entity.buyerId = req.buyerId
               entity.invAmt =req.invAmt
               entity.unitId = req.unitId
                entity.paymentType = CollectionPaymentTypes.RODTEP
                entity.iceGateStatus = req.status
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                console.log(save,'pppppppppppp');
                
                if(save){
              saveFlag.add(true)
                
            }
            else{
              saveFlag.add(false)
              await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong ')
            
        }
        }
        if(!(saveFlag.has(false))){
            await transactionManager.completeTransaction()
            return new CommonResponse(true,1,'Saved successfully')
        }else{
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in ice gate verfication')
        }
    }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in ice gate verfication',err)
        }
    }
async getDutyDrawBackTotals(req: DutyDrawBackDateReq): Promise<CommonResponse> {
    try {
        const manager = getManager();

        let query = `
          SELECT co.shipping_bill_date as shippingBillDate,
            SUM(CASE WHEN ddb_amt=0 AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN ((c.total_amount - c.freight_charges) * c.exchange_rate )* 0.033   ELSE 0 END) AS bmrIndToBeRecived,
            SUM(CASE WHEN ddb_amt=0 AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN ((c.total_amount - c.freight_charges) * c.exchange_rate )* 0.033 ELSE 0 END) AS bmrExportstoBeRecived,

            SUM(CASE WHEN ddb_amt>0 AND uc.company ='BMR INDUSTRIES PRIVATE LIMITED' THEN ddb_amt ELSE 0 END) AS bmrIndReceived,
            SUM(CASE WHEN ddb_amt>0 AND uc.company !='BMR INDUSTRIES PRIVATE LIMITED' THEN ddb_amt ELSE 0 END) AS bmrExportsReceived

            FROM ${appSettings.sales_db}.customer_invoice c
            LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = c.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = c.sale_order_id
            LEFT JOIN ${appSettings.logistics_db}.container co 
                            ON co.sale_order_id = c.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc
                            ON uc.unit_code_id = c.exporter_id
            WHERE so.status != 'CANCELLED' 
            AND sot.container_status = 'SHIPPED' 
            AND so.so_process_type ='MTO'
             AND co.mode_of_export != '${ModeOfExportEnum.FLIGHT}' 
             and c.is_active=1
        `;

        // Optional date filter
        if (req.fromDate && req.toDate) {
            query += ` AND DATE(co.shipping_bill_date) BETWEEN "${req.fromDate}" AND "${req.toDate}"`;
        }

        query += ` GROUP BY c.exporter_id, co.shipping_bill_date`;

        const infoQuery = await manager.query(query);

        if (infoQuery.length > 0) {
            return new CommonResponse(true, 1, 'Data retrieved successfully', infoQuery);
        } else {
            return new CommonResponse(false, 0, 'No data Found', []);
        }
    } catch (error) {
        throw error;
    }
}


    async getReceivePoData(req:PaymentTypeReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = ` SELECT r.invoice_number AS invoiceNumber ,r.invoice_date AS invoiceDate,ci.sale_order_id as soId,ci.financial_year as financeYear,
            sale_amount AS saleAmount,discount_rate AS discountRate, final_sale_amount AS finalSaleAmount,r.customer,ci.rodtep_status AS rodtepStatus FROM ${appSettings.finance_db}.rodtep r
            LEFT JOIN ${appSettings.finance_db}.collections co ON co.id = r.collection_id
            LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON ci.sale_order_id = co.so_id and ci.is_active=1
            WHERE ci.rodtep_status = '${RodtepStatus.SOLD}' and ci.rodtep_status != '${RodtepStatus.RECEIVED}'
             `
             if(req.financeYear ){
                query += ` AND ci.financial_year = '${req.financeYear}' `
            }
             if(req.unitId ){
                query += ` AND ci.exporter_id = '${req.unitId}' `
            }
            query += `GROUP BY r.invoice_number`
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
        
    }
    async updateSaleReceived(req: SaleReceiveReq): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager();
        const manager = getManager();
    
        try {
    
            await transactionManager.startTransaction();
            const saveFlag = new Set<boolean>();
    
            const query = `SELECT c.so_id FROM rodtep r 
                           LEFT JOIN collections c ON c.id = r.collection_id  
                           WHERE r.invoice_number = "${req.invoiceNumber}"`;
            const result = await manager.query(query);
    
            console.log(result, 'Query result');
    
            if (result.length > 0) {
                for (const row of result) {
                    console.log(row,'oooooo');
                    
                    const soId = row.so_id;
                    const update = await this.soRepo.updateSaleReceived({ soId, invoiceNumber: req.invoiceNumber });
                    console.log(update,'ooooooooooo');
                    
                    if (update) {
                        saveFlag.add(true);
                    } else {
                        saveFlag.add(false);
                    }
                }
    
                if (!saveFlag.has(false)) {
                    await transactionManager.completeTransaction();
                    return new CommonResponse(true, 1, 'Saved successfully');
                } else {
                    await transactionManager.releaseTransaction();
                    return new CommonResponse(false, 0, 'Something went wrong in receiving sale amount');
                }
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, `Data not found against ${req.invoiceNumber}`);
            }
        } catch (err) {
            console.error(err);
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, 'Something went wrong in receiving sale amount', err);
        }
    }
    

    async getDutyDrawBackReport(req:DutyDrawBackReportReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT ci.invoice_number AS invoiceNumber, DATE_FORMAT(ci.invoice_date, '%Y-%m-%d') AS invoiceDate,
            c.shipping_bill_no AS shippingBillNo, DATE_FORMAT(c.shipping_bill_date, '%Y-%m-%d') AS shippingBillDate,
            ec.end_customer_name AS partyName,
            ((ci.total_amount-ci.freight_charges)*ci.exchange_rate) AS fobValueInr,
            (((ci.total_amount-ci.freight_charges)*ci.exchange_rate)*0.033) AS balanceDutyDrawBack
            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.sales_db}.sale_order s ON s.sale_order_id =ci.sale_order_id
            LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id =ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
            WHERE 1=1 AND (ci.ddb_amt = 0 or ci.ddb_amt is NULL) AND c.mode_of_export != '${ModeOfExportEnum.FLIGHT}'  AND sot.container_status = 'SHIPPED' AND s.status !='CANCELLED'  AND s.so_process_type ='MTO' and ci.is_active=1`
            if(req.fromDate && req.toDate){
                query += ' And DATE(c.shipping_bill_date) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"'
            }
            if(req.invoiceNumber){
                query += ` AND ci.invoice_number = '${req.invoiceNumber}'`
            }
            query +=` GROUP BY ci.invoice_number`
            const result = await manager.query(query);
    
            if (result.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }

    async getAllInvoiceNumber(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT ci.invoice_number AS invoiceNumber
                         FROM ${appSettings.sales_db}.customer_invoice ci
                         WHERE 1=1 and ci.is_active=1
                         GROUP BY ci.invoice_number`;

            
            const result = await manager.query(query);
    
            if (result.length > 0) {
                return new CommonResponse(true, 101, 'Data retrieved successfully', result);
            } else {
                return new CommonResponse(false, 100, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    async generateIgstPayment(req:IgstCollectionsReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            const entity = new CollectionsEntity()
                entity.shippingBillNo = req.shippingBillNo
                entity.buyerId = req.buyerId
                entity.shippingBillDate = req.shippingBillDate?new Date(req.shippingBillDate):null
                entity.invAmt = req.invAmt
                entity.invNum = req.invNum
                entity.recievedAmt = req.recievedAmt
                entity.soId = req.soId
                entity.recievedDate = req.recievedDate ? new Date(req.recievedDate):null
                entity.remarks = req.remarks
                entity.createdUser = req.createdUser
                entity.unitId = req.unitId
                entity.paymentType = req.payment
                entity.receivedAmtInr = req.receivedAmountInr
                entity.exchangeRate = req.exchangeRate
                const save = await transactionManager.getRepository(CollectionsEntity).save(entity)
                // console.log(save,'saveeeeeeeeeeee')
if(save){
    // console.log('uuuuuuuuuuuuuu');
    const  exist = await this.soRepo.getCustInvoiceDetails({saleOrderId:req.soId})    
    const request = new PaymentReq()
    request.soId = req.soId
    request.collection = req.receivedAmountInr
    if(exist){
    const update = await this.soRepo.updateIgst(request)
    if(update){
        saveFlag.add(true)
    }else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'Something went wrong ')
    }
}else{
    saveFlag.add(false)
    await transactionManager.releaseTransaction()
    return new CommonResponse(false,0,'No invoice found')
}
}
            // const result = await manager.query(query)
            // if(result.length > 0){
            //     return new CommonResponse(true, 1,'Data retrieved successfully', result)
            // }else{
            //     return new CommonResponse(false, 0,'No data found',[])
            // }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in IGST payment')
            }
        }catch(err){
        console.log(err);
        
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in IGST payment',err)
        }
    }
   
    async getIgstData(req: CollectionsFilters): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let dutyquery = `SELECT
                c.shipping_bill_no as shippingBillNo, 
                co.cha, co.port_code as portCode,c.inv_num as invNum, c.inv_amt as invAmt,c.received_amt_inr as recievedAmt,
                DATE(c.received_date) as receivedDate, DATE(c.shipping_bill_date) as shippingBillDate, c.remarks,
                ec.end_customer_name as endCustomerName,con.country_name as country,c.received_amt_inr as receivedAmountInr,c.exchange_rate as exchangeRate,(ci.total_amount-ci.freight_charges) as fobvalue,c.inv_amt as tax
                FROM ${appSettings.finance_db}.collections c
                LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = c.so_id 
                LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.buyer_id
                left join ${appSettings.masters_db}.countries con on con.country_id  = ec.country_id 
                left join ${appSettings.sales_db}.sale_order_items so on so.sale_order_id = c.so_id
                left join  ${appSettings.sales_db}.customer_invoice ci on ci.sale_order_id = c.so_id and ci.is_active=1

                WHERE c.payment_type = "${CollectionPaymentTypes.IGST}" `;
        
    
            if (req.buyer) {
                dutyquery += ` AND c.buyer_id = '${req.buyer}' `;
            }
            if (req.invNo) {
                dutyquery += ` AND c.inv_num = '${req.invNo}' `;
            }
    dutyquery += ` GROUP BY c.inv_num`
            const result2 = await manager.query(dutyquery);
            if (result2.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result2);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
     async getIGSTAmountReport(req:IgstReportReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT 
             ci.unit_id AS unitId,uc.company,ci.financial_year AS financialYear,
    SUM(CASE 
            WHEN ci.igst_amt = 0 AND ci.unit_id = 1 
            THEN soi.inv_amount * ci.exchange_rate * (COALESCE(t.tax_percentage, 0) / 100) 
            ELSE 0 
        END) AS bmrIndToBeRecived,
    SUM(CASE 
            WHEN ci.igst_amt = 0 AND ci.unit_id = 25 
            THEN soi.inv_amount * ci.exchange_rate * (COALESCE(t.tax_percentage, 0) / 100) 
            ELSE 0 
        END) AS bmrExportstoBeRecived,
    SUM(CASE 
            WHEN ci.igst_amt != 0 AND ci.unit_id = 1 
            THEN ci.igst_amt 
            ELSE 0 
        END) AS bmrIndReceived,
    SUM(CASE 
            WHEN ci.igst_amt != 0 AND ci.unit_id = 25 
            THEN ci.igst_amt 
            ELSE 0 
        END) AS bmrExportsReceived

            FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = so.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
            WHERE 
            ci.is_tax_applicable = 'YES' 
            AND ci.invoice_category = 'IGST' 
            AND so.status != 'CANCELLED' 
            AND sot.container_status = 'SHIPPED' 
            AND so.so_process_type = 'MTO' 
            AND ci.unit_id IN (1, 25) and ci.is_active=1
            `; 
            if(req.financeYear){
              query+=` AND ci.financial_year='${req.financeYear}'`
        }     
                    query += ` GROUP BY ci.unit_id`;

            const result = await manager.query(query,[req.financeYear]);
    
            if (result.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
     async getIGSTAgingReport(req:IgstReportReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query = `SELECT soin.po_number AS poNumber,ci.invoice_number AS invNumber,ci.unit_id,DATE_FORMAT(ci.invoice_date, '%y-%m-%d') AS invDate,DATE(c.shipping_bill_date) AS shippingBillDate,c.shipping_bill_no
AS shipingBillNo,ci.end_customer_id,ec.end_customer_name AS endCustomer,uc.company,uc.unit_name AS unitName,ci.financial_year,SUM(soi.inv_amount) AS invAMT,t.tax_percentage AS taxPER,ci.exchange_rate AS exchangeRate, 
SUM(soi.inv_amount * ci.exchange_rate * (COALESCE(t.tax_percentage, 0) / 100)) AS igstAmount
FROM ${appSettings.sales_db}.customer_invoice ci
            LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = so.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
            LEFT JOIN ${appSettings.logistics_db}.container c ON c.sale_order_id = ci.sale_order_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details soin ON soin.sale_order_id = so.sale_order_id

            WHERE
            ci.is_tax_applicable = 'YES'
            AND ci.invoice_category = 'IGST'
            AND so.status != 'CANCELLED'
            AND sot.container_status = 'SHIPPED'
            AND so.so_process_type = 'MTO'
            AND ci.igst_amt = 0
            and ci.is_active=1
            `;    
            if(req.invNum){
              query+=` AND ci.invoice_number='${req.invNum}'`
        }  
        if(req.financeYear){
              query+=` AND ci.financial_year='${req.financeYear}'`
        }
        
            if(req.fromDate && req.toDate){
                query += ' And DATE(ci.invoice_date) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"'
            }
        if(req.unitId){
              query+=` AND ci.unit_id=${req.unitId}`
        } 
        if(req.partyName){
              query+=` AND ci.end_customer_id=${req.partyName}`
        }  
         
        // if (!req.invNum ) {
            query += ` GROUP BY ci.invoice_number`;
        // }

            const result = await manager.query(query);
            if (result.length > 0) {
                return new CommonResponse(true, 1, 'Data retrieved successfully', result);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
    async getRMInvoiceWiseData(req:AgingReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
            let query = `SELECT 
                 CASE 
                    WHEN gi.broker = 0 THEN gi.farmer
                    WHEN gi.farmer = 0 THEN gi.broker
                    ELSE gi.broker
                END AS farmerId,
                CASE 
                    WHEN gi.broker = 0 THEN su.name
                    WHEN gi.farmer = 0 THEN s.name
                    ELSE s.name
                    END AS farmerName,rmi.invoice_number AS invNo,rmi.invoice_date AS invDate,i.supplier_type AS supplierType ,gi.tds_applicable AS tds,rmi.plant_id as unitId,uc.plant_code as unitName,
            gi.taxable_amount AS taxAmount,SUM(rmi.quantity * rmi.unit_price) AS totalamount,((gi.taxable_amount)*(0.001)) AS tdsAmount,rmi.payment,
            DATEDIFF(DATE('${finalDate}'), DATE(rmi.invoice_date)) AS aging
            FROM ${appSettings.rm_procure_db}.rm_invoice rmi
            LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id= rmi.grn_item_id
            LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
            LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.broker AND i.supplier_type = 'DEALER'
            LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id =gi.farmer AND i.supplier_type != 'DEALER'
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id =rmi.plant_id
            WHERE 1=1`;   
            if (req.fromDate && req.toDate) {
            query += ` AND DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            if(req.unitId){
            query += ` AND rmi.plant_id = ${req.unitId}`
              } 
            query += ` GROUP BY rmi.invoice_number,rmi.grn_item_id;`;

            const result = await manager.query(query);
            let res=[]
            if (result.length > 0) {
                 const invoiceMap = new Map();
                for(const val of result){
                     if (!invoiceMap.has(val.invNo)) {
                    invoiceMap.set(val.invNo, {
                        farmerId: val.farmerId,
                        farmerName: val.farmerName,
                        invNo: val.invNo,
                        invDate: val.invDate,
                        supplierType: val.supplierType,
                        tds: val.tds,
                        unitId: val.unitId,
                        unitName: val.unitName,
                        taxAmount: 0,
                        totalamount: 0,
                        tdsAmount: 0,
                        payment: 0,
                        aging: val.aging, // We'll take the max aging later
                        items: []
                    });
                }
                 const invoice = invoiceMap.get(val.invNo);
                invoice.taxAmount += Number(val.taxAmount || 0);
                invoice.totalamount += Number(val.totalamount || 0);
                invoice.tdsAmount += Number(val.tdsAmount || 0);
                invoice.payment += Number(val.payment || 0);
                invoice.items.push(val);
                 if (val.aging > invoice.aging) {
                    invoice.aging = val.aging;
                }
            }
            for (const [invNo, invoice] of invoiceMap) {
                     let agingRange = '';
                const agingDays = invoice.aging;
                if (agingDays <= 10) {
                    agingRange = '0-10';
                } else if (agingDays <= 20) {
                    agingRange = '10-20';
                } else if (agingDays <= 30) {
                    agingRange = '20-30';
                }else if (agingDays <= 40) {
                    agingRange = '30-40';
                }else if (agingDays <= 50) {
                    agingRange = '40-50';
                }else if (agingDays <= 60) {
                    agingRange = '50-60';
                } else if (agingDays <= 80) {
                    agingRange = '60-80';
                }else {
                    agingRange = '80+';
                }
                //     res.push({
                //         farmerName:val.farmerName,
                //         tdsAmount:val.tdsAmount,
                //     unitId:val.unitId,
                //     unitName:val.unitName,
                //     company :val.company,
                //     totalAmount:Number(val.totalamount),
                //     pending: Math.round(Number(Number(val.totalamount || 0) - Number(val.payment || 0) - Number(val.tdsAmount || 0))).toFixed(0),                   
                //     aging:val.aging,
                //     agingBucket:agingRange,
                //     invoiceDate:val.invDate,
                //     invNo:val.invNo
                // })
                // }
                res.push({
                    farmerName: invoice.farmerName,
                    tdsAmount: invoice.tdsAmount,
                    unitId: invoice.unitId,
                    unitName: invoice.unitName,
                    company: invoice.company,
                    totalAmount: Number(invoice.totalamount),
                    pending: Math.round(Number(invoice.totalamount || 0) - Number(invoice.payment || 0) - Number(invoice.tdsAmount || 0)),
                    aging: invoice.aging,
                    agingBucket: agingRange,
                    invoiceDate: invoice.invDate,
                    invNo: invoice.invNo
                });
            }
                return new CommonResponse(true, 1, 'Data retrieved successfully', res);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
     async getPMInvoiceWiseData(req:AgingReq): Promise<CommonResponse> {
        try {
            const manager = getManager();
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
            let query = `
            SELECT g.vendor_id AS vendorId, g.inv_no AS invNo,g.invoice_date AS invDate,v.vendor_name AS vendorName,g.unit_id AS unitId,uc.plant_code AS unitName,uc.company,
                   SUM(gi.tot_amount ) AS totalamount,
                   sum(gi.taxable_amount *0.001) AS tdsAmount,
                   SUM((gi.received_quantity * gi.unit_price) * (COALESCE(t.tax_percentage, 0) / 100)) AS tax,
                   (g.payment) AS payment,
                   DATEDIFF(DATE('${finalDate}'), DATE(g.invoice_date)) AS aging
            FROM ${appSettings.procure_db}.grn g
            LEFT JOIN ${appSettings.procure_db}.grn_items gi ON gi.grn_id = g.grn_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = gi.tax_per
            LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = g.vendor_id
           LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=g.unit_id
            WHERE 1=1`;  
            if (req.fromDate && req.toDate) {
            query += ` AND DATE(g.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            if(req.unitId){
            query += ` AND g.unit_id = ${req.unitId}`
              } 
            query += ` GROUP BY g.inv_no;`;
   const result = await manager.query(query);
            let res=[]
            if (result.length > 0) {
                for(const val of result){
                     let agingRange = '';
                const agingDays = val.aging;
                if (agingDays <= 10) {
                    agingRange = '0-10';
                } else if (agingDays <= 20) {
                    agingRange = '10-20';
                } else if (agingDays <= 30) {
                    agingRange = '20-30';
                }else if (agingDays <= 40) {
                    agingRange = '30-40';
                }else if (agingDays <= 50) {
                    agingRange = '40-50';
                }else if (agingDays <= 60) {
                    agingRange = '50-60';
                } else if (agingDays <= 80) {
                    agingRange = '60-80';
                }else {
                    agingRange = '80+';
                }
                    res.push({
                        vendorName:val.vendorName,
                        tdsAmount:val.tdsAmount,
                        unitId:val.unitId,
                        unitName:val.unitName,
                        company :val.company,
                    totalAmount:Number(val.totalamount),
                    pending: Math.round(Number(Number(val.totalamount || 0) - Number(val.payment || 0) - Number(val.tdsAmount || 0))).toFixed(0),                   
                    aging:val.aging,
                    agingBucket:agingRange,
                    invoiceDate:val.invDate,
                    invNo:val.invNo
                })
                }
                return new CommonResponse(true, 1, 'Data retrieved successfully', res);
            } else {
                return new CommonResponse(false, 0, 'No data found', []);
            }
        } catch (err) {
            throw err;
        }
    }
async getVendorPackTaxData(req: IgstReportReq): Promise<CommonResponse> {
    try {
        const manager = getManager();
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
        let invoiceQuery = `
            SELECT g.vendor_id AS vendorId, g.inv_no AS invNo,g.invoice_date AS invDate,v.vendor_name AS vendorName,g.unit_id AS unitId,uc.unit_name AS unitName,uc.company,
                   SUM(gi.tot_amount) AS totalamount,
                   sum(gi.taxable_amount *0.001) AS tdsAmount,
                   SUM((gi.received_quantity * gi.unit_price) * (COALESCE(t.tax_percentage, 0) / 100)) AS tax,
    (g.payment) AS payment,
                   DATEDIFF(DATE('${finalDate}'), DATE(g.invoice_date)) AS aging
            FROM ${appSettings.procure_db}.grn g
            LEFT JOIN ${appSettings.procure_db}.grn_items gi ON gi.grn_id = g.grn_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = gi.tax_per
            LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = g.vendor_id
           LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=g.unit_id
            WHERE gi.tds_applicable = 1`;
        if (req.fromDate && req.toDate) {
            invoiceQuery += ` AND DATE(g.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
        if (req.unitId) {
            invoiceQuery += ` AND g.unit_id = ${req.unitId}`;
        }
        if (req.partyName) {
            invoiceQuery += ` AND g.vendor_id = ${req.partyName}`;
        }

        invoiceQuery += ` GROUP BY g.vendor_id, g.inv_no`;
        const invoiceData = await manager.query(invoiceQuery);
     

    if (invoiceData.length > 0) {
            // Transform the data into the desired format
            const vendorMap = new Map();
            
            // Using for loop instead of forEach
            for (const item of invoiceData) {
                // const item = invoiceData[i];
                
                // Calculate aging bucket
                let agingBucket = '';
                const agingDays = item.aging;
                if (agingDays <= 30) {
                    agingBucket = '0-30';
                } else if (agingDays <= 60) {
                    agingBucket = '30-60';
                } else if (agingDays <= 80) {
                    agingBucket = '60-80';
                } else {
                    agingBucket = '80+';
                }
                
                // Format invoice date
                const invDate = moment(item.invDate).format('DD-MM-YYYY');
                
                const invoice = {
                    invNo: item.invNo,
                    invDate: item.invDate,
                    totalAmount: Number(item.totalamount).toFixed(2),
                    tax: Number(item.tdsAmount || 0).toFixed(2),
                    balance: Math.round(Number(Number(item.totalamount || 0) - Number(item.payment || 0) - Number(item.tdsAmount || 0))).toFixed(2),
                    agingDays: agingDays,
                    agingBucket: agingBucket,
                    unitName: item.unitName,
 unitId: item.unitId,
                company:item.company,
                };
                
                if (!vendorMap.has(item.vendorId)) {
                    vendorMap.set(item.vendorId, {
                        vendorName: item.vendorName,
                        vendorId: item.vendorId,
               
                        invoices: []
                    });
                }
                
                vendorMap.get(item.vendorId).invoices.push(invoice);
            }
            
            const result = {
                vendors: Array.from(vendorMap.values())
            };
    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  }else {
        return new CommonResponse(false, 0, 'No data found');
      } } catch (err) {
                            throw err;
                        }
                    }
async getVendorRMTaxData(req:IgstReportReq):Promise<CommonResponse>{
        try{
        const manager = getManager();
        // const finalDate = moment(req.toDate).format('YYYY-MM-DD');
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
        let invoiceQuery =`
         SELECT 
         CASE 
                    WHEN gi.broker = 0 THEN gi.farmer
                    WHEN gi.farmer = 0 THEN gi.broker
                    ELSE gi.broker
                END AS farmerId,
                CASE 
                    WHEN gi.broker = 0 THEN su.name
                    WHEN gi.farmer = 0 THEN s.name
                    ELSE s.name
                END AS farmerName,rmi.invoice_number AS invNo,rmi.invoice_date AS invDate,i.supplier_type AS supplierType ,gi.tds_applicable AS tds,rmi.plant_id as unitId,uc.company as unitName,
            gi.taxable_amount AS taxAmount,SUM(rmi.quantity * rmi.unit_price) AS totalamount,((gi.taxable_amount)*(0.001)) AS tdsAmount,rmi.payment,
            DATEDIFF(DATE('${finalDate}'), DATE(rmi.invoice_date)) AS aging
            FROM ${appSettings.rm_procure_db}.rm_invoice rmi
            LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
            LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.broker AND i.supplier_type = 'DEALER'
            LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id = gi.farmer AND i.supplier_type != 'DEALER'
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id =rmi.plant_id
            LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id= rmi.grn_item_id
            WHERE gi.tds_applicable = 1
            `
            if (req.fromDate && req.toDate) {
            invoiceQuery += ` AND DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            if(req.unitId){
            invoiceQuery += ` AND rmi.plant_id = ${req.unitId}`
              } 
            invoiceQuery += ` GROUP BY rmi.invoice_number;`;
        const invoiceData = await manager.query(invoiceQuery);

        if (invoiceData.length > 0) {
            // Transform the data into the desired format
            const vendorMap = new Map();
            
            // Using for loop instead of forEach
            for (const item of invoiceData) {
                // const item = invoiceData[i];
                
                // Calculate aging bucket
                let agingBucket = '';
                const agingDays = item.aging;
                if (agingDays <= 10) {
                    agingBucket = '0-10';
                } else if (agingDays <= 20) {
                    agingBucket = '10-20';
                } else if (agingDays <= 30) {
                    agingBucket = '20-30';
                }else if (agingDays <= 40) {
                    agingBucket = '30-40';
                }else if (agingDays <= 50) {
                    agingBucket = '40-50';
                }else if (agingDays <= 60) {
                    agingBucket = '50-60';
                } else if (agingDays <= 80) {
                    agingBucket = '60-80';
                }else {
                    agingBucket = '80+';
                }
                
                // Format invoice date
                const invDate = moment(item.invDate).format('DD-MM-YYYY');
                
                const invoice = {
                    invNo: item.invNo,
                    invDate: item.invDate,
                    totalAmount: Number(item.totalamount).toFixed(2),
                    tax: Number(item.tdsAmount || 0).toFixed(2),
                balance: Math.round(Number(Number(item.totalamount || 0) - Number(item.payment || 0) - Number(item.tdsAmount || 0))).toFixed(2), 
                    agingDays: agingDays,
                    agingBucket: agingBucket,
                    unitName: item.unitName,
                    unitId: item.unitId,
                   company:item.company,
                };
                
                if (!vendorMap.has(item.farmerId)) {
                    vendorMap.set(item.farmerId, {
                        vendorName: item.farmerName,
                        vendorId: item.vendorId,
                
                        invoices: []
                    });
                }
                
                vendorMap.get(item.farmerId).invoices.push(invoice);
            }
            
            const result = {
                vendors: Array.from(vendorMap.values())
            };
    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  }else {
        return new CommonResponse(false, 0, 'No data found');
      }
        }catch(err){
        throw (err);
        }
        }

      async getRmSuppliers():Promise<CommonResponse>{
        try{
        const manager = getManager();
        let query =`
        SELECT f.supplier_id as farmerId,b.supplier_id as dealerId,f.name AS farmer, b.name AS dealer,i.supplier_type as type FROM ${appSettings.rm_procure_db}.rm_invoice ri
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = ri.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id
        LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
        LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.broker = b.supplier_id AND i.supplier_type ='Dealer'
        WHERE ri.payment_status !='${PayablePaymentStatusEnum.PAID}' AND gi.farmer IS NOT NULL AND gi.broker IS NOT NULL group by gi.broker,gi.farmer`
        const result = await manager.query(query);
        return new CommonResponse(true,1,'Data retrieved successfully', result)
        }catch(err){
        throw (err);
        }
        }

        async getPackingVendors(req?:PayableFilterRequest):Promise<CommonResponse>{
try{
    const manager = getManager();
    let query =`SELECT g.inv_no as invoiceNum,g.grn_id as invoiceId,g.vendor_id as vendorId,v.vendor_name AS vendor FROM ${appSettings.procure_db}.grn g 
    LEFT JOIN ${appSettings.masters_db}.vendors v ON g.vendor_id = v.vendor_id
WHERE g.payment_status !='${PayablePaymentStatusEnum.PAID}'`
//  if(req.invoiceNumber!= undefined){
//         query = query + ` and g.inv_no ='${req.invoiceNumber}'`
//     }
    query = query + ` GROUP BY g.vendor_id`
    const result = await manager.query(query);
return new CommonResponse(true,1,'Data retrieved successfully', result)
}catch(err){
    throw (err);
}
    }
        async getRmInvoices():Promise<CommonResponse>{
        try{
            
        const manager = getManager();
        let query =`
        SELECT ri.invoice_number AS invoiceNumber,ri.invoice_number as invoiceId,ri.batch_number as batch ,gi.year FROM ${appSettings.rm_procure_db}.rm_invoice ri
        LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = ri.grn_item_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id
        LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id = i.indent_id
        WHERE ri.payment_status !='PAID' GROUP BY ri.invoice_number `
        const result = await manager.query(query);
        return new CommonResponse(true,1,'Data retrieved successfully', result)
        }catch(err){
        throw (err);
        }
        }
    async getPackingInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
try{

    const manager = getManager();
    let query =`  SELECT g.inv_no as invoiceNumber,g.grn_id as invoiceId  FROM ${appSettings.procure_db}.grn g WHERE g.payment_status !='PAID'  `
     if(req.supplierId) {
    query = query + ` AND g.vendor_id = '${req.supplierId}' `
    }
      if(req.unit) {
    query = query + ` AND g.unit_id = '${req.unit}' `
    }
    query = query +` group by g.inv_no`
    const result = await manager.query(query);
return new CommonResponse(true,1,'Data retrieved successfully', result)
}catch(err){
    throw (err);
}
    }
async getRmPayables(req?:PayableFilterRequest):Promise<CommonResponse>{
        // console.log(req,'ppppppppppppp');
        
        try{
 const manager = getManager();
//  const invoiceList = req.map(inv => `'${inv}'`).join(',');
    let query =`SELECT ri.grn_item_id AS invoiceId,ri.invoice_number AS invoiceNumber,ri.quantity as quantity,ri.unit_price AS unitPrice,total_amount as amount,ri.total_amount,i.supplier_type AS supplierType,f.name AS farmer, b.name AS dealer,ri.count AS count,
i.indent_code AS indentNumber,p.name AS item,DATE_FORMAT(ri.invoice_date, '%Y-%m-%d') AS invoiceDate,(gi.taxable_amount)AS deduction,gi.tds_applicable AS tdsApplicable,ri.batch_number as batch,ri.payment,d.defect_name as deffect,ri.type
FROM ${appSettings.rm_procure_db}.rm_invoice ri 
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = ri.grn_item_id
LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id
LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id = i.indent_id
LEFT JOIN ${appSettings.masters_db}.suppliers f ON ii.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
LEFT JOIN ${appSettings.masters_db}.suppliers b ON ii.farmer = b.supplier_id AND i.supplier_type ='Dealer'
LEFT JOIN ${appSettings.masters_db}.products p ON ii.product = p.product_id
LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = ri.grn_id
left join ${appSettings.rm_procure_db}.grn_item_defects gid on ri.defect_id = gid.grn_item__defects_id and ri.type= 'DEFECT'
left join ${appSettings.masters_db}.defect d on d.defect_id= gid.defect_id
WHERE g.payment_status !='${PayablePaymentStatusEnum.PAID}' `
if(req.invoiceNumber){
    query = query + ` and ri.invoice_number ='${req.invoiceNumber}'`
}
    query= query + ` GROUP BY ri.rm_invoice_id`
    const result = await manager.query(query);
    //  const yearWiseTotals = new Map<string, { total: number; thresholdCrossed: boolean }>();

    //  const enrichedResult = result.map((record: any) => {
    //         const date = new Date(record.invoiceDate);
    //         const year = date.getFullYear();
    //         const month = date.getMonth() + 1;
    //         const financialYear = month < 4 ? `${year - 1}-${year}` : `${year}-${year + 1}`;
    //         const amount = Number(record.total_amount) || 0;

    //         // Initialize year-wise tracker
    //         if (!yearWiseTotals.has(financialYear)) {
    //             yearWiseTotals.set(financialYear, { total: 0, thresholdCrossed: false });
    //         }

    //         const yearData = yearWiseTotals.get(financialYear)!;
    //         yearData.total += amount;

    //         let deductionAmount = 0;
    //         let status = 'No';

    //         if (!yearData.thresholdCrossed && yearData.total > 5000000) {
    //             // First record that crosses threshold
    //             deductionAmount = yearData.total - 5000000;
    //             status = 'Yes';
    //             yearData.thresholdCrossed = true;
    //         } else if (yearData.thresholdCrossed) {
    //             // All later records in the same FY
    //             deductionAmount = amount;
    //             status = 'Yes';
    //         }

    //         return {
    //             ...record,
    //             financialYear,
    //             deductionAmount,
    //             status
    //         };
    //     });
return new CommonResponse(true,1,'Data retrieved successfully', result)

        }catch(err){
    throw (err);
}
    }
     async getPackingPayables(req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            console.log(req,'serviceeeeeeeeee');
            
 const manager = getManager();
    let query =`SELECT gi.grn_item_id AS invoiceId,gi.unit_price AS unitPrice,gi.received_quantity AS quantity,gi.tot_amount AS amount,p.po_number AS poNumber,g.inv_no AS invoiceNumber,t.tax_percentage AS taxPer, gi.tax_amount AS taxAmount,gi.taxable_amount AS deduction,gi.tds_applicable AS tdsApplicable,DATE_FORMAT(g.invoice_date, '%Y-%m-%d') AS invoiceDate,ic.item_category AS itemCategory,isc.item_sub_category AS itemSubCategory, i.item_name AS item,v.vendor_name AS vendor,g.payment as paidAmount,gi.discount_amount as discount,gi.discount_per as discountPer
FROM ${appSettings.procure_db}.grn_items gi 
LEFT JOIN ${appSettings.procure_db}.grn g ON g.grn_id = gi.grn_id
LEFT JOIN ${appSettings.procure_db}.purchase_order p ON p.purchase_order_id = gi.po_id
LEFT JOIN ${appSettings.masters_db}.vendors v ON g.vendor_id = v.vendor_id
LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = gi.tax_per
LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = gi.item_id
LEFT JOIN ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = gi.item_category_id
LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
WHERE g.payment_status !='${PayablePaymentStatusEnum.PAID}' `
    if(req.invoiceNumber!= undefined){
        query = query + ` and g.inv_no ='${req.invoiceNumber}'`
    }
    if(req.supplierId!= undefined){
        query = query + ` and g.vendor_id ='${req.supplierId}'`
    }
        const result = await manager.query(query);

    return new CommonResponse(true,1,'Data retrieved successfully', result)

        }catch(err){
    throw (err);
}
    }
     async savePayables(req:PayableRequest):Promise<CommonResponse>{
        try{
            const manager = getManager();
        const transactionManager = new GenericTransactionManager()
         await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            let payment =0
    // for(const req of request){
    const existPayment = await transactionManager.getRepository(PayableEntity).find({where:{invoiceType:req.invoiceType,invoiceNum:req.invoiceNumber}})
    if(existPayment.length>0){
          payment = existPayment.reduce((sum, invoice) => {
      return sum + Number(invoice.payment);
    }, 0);
    }
    let status1 = PayablePaymentStatusEnum.OPEN;

if (req.invoiceType == 'RM') {
    status1 = PayablePaymentStatusEnum.PAID;
} else {
    if (req.due === 0) {
        status1 = PayablePaymentStatusEnum.PAID;
    } else if (req.due != 0 && req.due != req.finalAmount) {
        status1 = PayablePaymentStatusEnum.PARTIALLY_PAID;
    }
}

if (req.invoiceType == 'RM') {

    if (!req.invoiceNumber) {

        await transactionManager.releaseTransaction();

        return new CommonResponse(
            false,
            0,
            "Invoice Number Missing"
        );

    }

    if (!req.vendorId) {

        await transactionManager.releaseTransaction();

        return new CommonResponse(
            false,
            0,
            "Supplier Missing"
        );

    }

    if (!req.receivedDate) {

        await transactionManager.releaseTransaction();

        return new CommonResponse(
            false,
            0,
            "Payment Date Missing"
        );

    }

    if (!req.payment || Number(req.payment) <= 0) {

        await transactionManager.releaseTransaction();

        return new CommonResponse(
            false,
            0,
            "Payment Amount should be greater than zero"
        );

    }

}

const entity = new PayableEntity();

entity.invoiceNum = req.invoiceNumber;
entity.vendorId = req.vendorId;
entity.receivedDate = new Date(req.receivedDate);
entity.invoiceType = req.invoiceType;
entity.createdUser = req.createdUser;
entity.updatedUser = req.createdUser;
entity.status = status1;
entity.invoiceDate = new Date(req.invoiceDate);

if (req.invoiceType == 'RM') {

    entity.invoiceId = 1;

    entity.quantity = req.quantity;

    entity.amount = req.invoiceAmount;

    entity.payment = req.payment;

    entity.deduction = 0;

    entity.tdsApplicable = false;

    entity.rmType = req.rmType;

    entity.taxId = req.taxId ? req.taxId : null;

    entity.dutyPercentage = req.dutyPercentage
        ? req.dutyPercentage
        : 0;

    entity.remarks = req.remarks ? req.remarks : '';

if (req.rmType == RMTypePaybleEnum.IGST) {

    entity.finalAmount =
        Number(req.invoiceAmount) +
        Number(req.taxAmount);

}
else if (req.rmType == RMTypePaybleEnum.DUTY_PAID) {

    entity.finalAmount =
        Number(req.invoiceAmount) +
        Number(req.dutyAmount);

}
else if (req.rmType == RMTypePaybleEnum.IMPORT_PAYABLE) {

    entity.status = req.transactionType =='FULL PAYMENT' ? PayablePaymentStatusEnum.PAID : req.transactionType == 'PART PAYMENT' ? PayablePaymentStatusEnum.PARTIALLY_PAID : PayablePaymentStatusEnum.OPEN;
    entity.currency = req.currency;
    entity.exchangeRate = req.exchangeRate;
    entity.receivedAmountInr = req.receivedAmountInr;
    entity.bankAccount = req.bankAccount;
    entity.bankCharges = req.bankCharges;
    entity.buyerShortPayment = req.buyerShortPayment;
    entity.amount = req.invoiceAmount
    entity.finalAmount = req.finalAmount;

}
else if (req.rmType == RMTypePaybleEnum.DOMESTIC) {

    entity.status = req.transactionType == 'FULL PAYMENT'
        ? PayablePaymentStatusEnum.PAID
        : req.transactionType == 'PART PAYMENT'
        ? PayablePaymentStatusEnum.PARTIALLY_PAID
        : PayablePaymentStatusEnum.OPEN;

    entity.bankAccount = req.bankAccount;
    entity.bankCharges = req.bankCharges;
    entity.buyerShortPayment = req.buyerShortPayment;

    entity.amount = req.invoiceAmount;
    entity.finalAmount = req.finalAmount;
}

} else {

    entity.invoiceId = req.invoiceId;

    entity.quantity = req.quantity;

    entity.amount = req.amount;

    entity.payment = req.payment;

    entity.deduction = req.deduction;

    entity.finalAmount = req.finalAmount;

    entity.tdsApplicable = req.tdsApplicable;

}

const save =
await transactionManager
.getRepository(PayableEntity)
.save(entity);
if(save){
  saveFlag.add(true);
  console.log(req.invoiceType == 'RM',req.invoiceType == 'PACKING',req.invoiceType);
  
if (req.invoiceType == 'RM') {

    // const rmInvoice = await manager.query(`
    //     SELECT payment
    //     FROM ${appSettings.rm_procure_db}.rm_invoice
    //     WHERE invoice_number='${req.invoiceNumber}'
    // `);

    // if (rmInvoice.length > 0) {

        saveFlag.add(true);

        const status = PayablePaymentStatusEnum.PAID;

        // const currentPayment =
        //     Number(rmInvoice[0]?.payment || 0);

        // const totalPayment =
        //     currentPayment + Number(req.payment);

        const updateQuery = `
            UPDATE ${appSettings.rm_procure_db}.grn
            SET
                payment_status='${status}'
            WHERE invoice_number='${req.invoiceNumber}'
        `;
       
        const rmUpdate =
            await manager.query(updateQuery);
          console.log(rmUpdate,'rmUpdate');
        if (
            (rmUpdate &&
                rmUpdate.affectedRows > 0) ||
            rmUpdate.length > 0
        ) {

            saveFlag.add(true);

        } else {

            saveFlag.add(false);

            await transactionManager.releaseTransaction();

            return new CommonResponse(
                false,
                0,
                "Unable to update RM Invoice Payment"
            );

        }

    // } 

}
else if(req.invoiceType == 'PACKING'){
const grn = await manager.query(`SELECT * FROM ${appSettings.procure_db}.grn WHERE inv_no ='${req.invoiceNumber}'`)
    if(grn.length>0){
         let status =PayablePaymentStatusEnum.OPEN
    if(req.due===0){
        status=PayablePaymentStatusEnum.PAID
    }else if(req.due!=0 && req.due!= req.finalAmount) {
          status=PayablePaymentStatusEnum.PARTIALLY_PAID
      
    }
    const payment = await manager.query(`SELECT sum(payment) as payment from ${appSettings.finance_db}.payables where invoice_type ='PACKING' and invoice_number ='${req.invoiceNumber}' `)
       
        const updateGrn =await manager.query(`update ${appSettings.procure_db}.grn SET payment_status ='${status}',payment = ${payment?.[0]?.payment?Number(Number(payment?.[0]?.payment)+req.payment):req.payment} where inv_no= '${req.invoiceNumber}'`)
        if(updateGrn.affectedRows>0){
                saveFlag.add(true);
        }else{
        saveFlag.add(false);
await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,`Something went wrong in updation of grn`)
        }
    //             const grnId = grnItems[0]?.grn_id;
    //             const grnItemsAll = await manager.query(`
    //     SELECT payment_status FROM ${appSettings.procure_db}.grn_items 
    //     WHERE grn_id = ${grnId}
    // `);
    // const hasPartialOrOpen = grnItemsAll.some(
    //     item => item.payment_status === PayablePaymentStatusEnum.PARTIALLY_PAID ||
    //             item.payment_status === PayablePaymentStatusEnum.OPEN
    // );

//     const grnStatus = hasPartialOrOpen
//         ? PayablePaymentStatusEnum.PARTIALLY_PAID
//         : PayablePaymentStatusEnum.PAID;

//  const grnUpdate =  await manager.query(`update ${appSettings.procure_db}.grn set payment_status ='${grnStatus}' where grn_id =${grnId}`)
//              if(grnUpdate.affectedRows>0){
//                 saveFlag.add(true);
//              }  else{
//                 saveFlag.add(false);
// await transactionManager.releaseTransaction()
//                 return new CommonResponse(false,0,`Something went wrong in payment of Invoice Number ${req.invoiceNumber}`)
//              }
        // const grn =await manager.query(`select * from ${appSettings.procure_db}.grn_items where grn_id = ${grnItems.grn_id}`)
        // if(grn.length>0){
        //     for(const rec of grn){
        //         if(rec.payment_status != PayablePaymentStatusEnum.PAID){
        //              const grnUpdate =  await manager.query(`update ${appSettings.procure_db}.grn set payment_status ='${PayablePaymentStatusEnum.PARTIALLY_PAID}' where grn_id =${rec.grn_id}`)
        //         }
        //     }
        // }
       
    }else{
        saveFlag.add(false);
await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,`Something went wrong in payment of Invoice Number ${req.invoiceNumber}`)
   
    }
  }
} else {
saveFlag.add(false);
await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,`Something went wrong`)
          
}
    // }
      if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in payment')
            }
//     const result = await manager.query(query);
// return new CommonResponse(true,1,'Data retrieved successfully', result)

        }catch(err){
            console.log(err,'errrrrrrrrrrr');
            
    throw (err);
}
    }


    async getPayablesForPacking(req:PayableFilterRequest):Promise<CommonResponse>{
        try{
        const manager = getManager();
        let query =`
        SELECT pa.id AS payableId,pa.invoice_type AS invoiceType,pa.invoice_id AS invoiceId,pa.status,pa.invoice_number AS invoiceNumber,
        pa.vendor_id,Date(pa.received_date) AS receivedDate,gi.received_quantity as quantity,(gi.received_quantity*gi.unit_price) as amount,(gi.taxable_amount*0.001) as deduction,pa.final_amount AS finalAmount,gi.tax_amount AS taxAmount,i.item_name as item,i.item_id as itemId,gi.discount_amount,gi.discount_per as discountPer,
        pa.payment,po.po_number AS poNumber,v.vendor_name AS vendorName,Date(pa.invoice_date) AS invoiceDate,pa.payment as paidAmount
        FROM ${appSettings.finance_db}.payables pa
        LEFT JOIN ${appSettings.procure_db}.grn g ON g.inv_no=pa.invoice_number
        left join ${appSettings.procure_db}.grn_items gi on gi.grn_id = g.grn_id
        LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = gi.item_id
        LEFT JOIN ${appSettings.procure_db}.purchase_order po ON po.purchase_order_id=gi.po_id
        LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id=pa.vendor_id
        WHERE pa.invoice_type='PACKING'`
        if(req.invoiceFromDate != undefined){
            query = query+=` AND Date(pa.invoice_date) Between  '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
        }
         if(req.receivedFromDate != undefined){
            query = query+=` AND Date(pa.received_date) Between  '${req.receivedFromDate}' and '${req.receivedToDate}'`
        }
        if(req.invoiceNumber != undefined){
             query = query+=` AND pa.invoice_number='${req.invoiceNumber}'`
        }
         if(req.supplierId != undefined){
             query = query+=` AND pa.vendor_id='${req.supplierId}'`
        }
         if(req.unit != undefined){
             query = query+=` AND po.unit_id='${req.unit}'`
        }
        // query = query+= `Group by pa.id`
        const data = await manager.query(query);
//         const groupedData = data.reduce((result, current) => {
//             const { payableId, invoiceType, status, invoiceNumber, receivedDate, quantity,amount,deduction,finalAmount,payment,poNumber,vendorName,invoiceId,invoiceDate,taxAmount} = current;
      
//             let packingGroup = result.find(item => item.invoiceNumber === invoiceNumber);
//             if (!packingGroup) {
//               packingGroup = {
//                 invoiceNumber,
//                 invoiceDate,
//                 // receivedDate,
//                 invoiceType,
//                 vendorName,
//                 invoiceId,
//                 poNumber,
//                 products: [],
//                 payments:[]
//               };
//               result.push(packingGroup);
//             }
//       const productExists = packingGroup.products.some(p => p.payableId === payableId)
//                if (packingGroup&&!productExists) {
//     packingGroup.products.push({
//       payableId,
//       quantity,
//       amount,
//       deduction,taxAmount
//     });
//   }
//         const paymentExists = packingGroup.payments.some(p => p.receivedDate === receivedDate);
//   if (packingGroup && !paymentExists) {
//     console.log();
    
//     packingGroup.payments.push({
//       finalAmount,
//       payment,
//       status,
//       receivedDate,
//     });
// }
      
//             return result;
//           }, []);
      
      const invoiceMap = new Map<string, any>()
      
    for (const row of data) {
      const invoiceNumber = row.invoiceNumber;

      if (!invoiceMap.has(invoiceNumber)) {
        invoiceMap.set(invoiceNumber, {
          invoiceNumber: invoiceNumber,
          vendorId: row.vendor_id,
          vendorName: row.vendorName,
          invoiceDate: row.invoiceDate,
          poNumber:row.poNumber,
          finalAmount: row.finalAmount,
          payments: [],
          products: new Map<number, any>()
        });
      }

      const entry = invoiceMap.get(invoiceNumber);

      // Add item only if exists (grn_item may be null for some rows)
    if (row.itemId && !entry.products.has(row.itemId)) {
    entry.products.set(row.itemId, {
      itemId: row.itemId,
      itemName: row.item,
      quantity: row.quantity,
      amount: row.amount,
      deduction: row.deduction,
      taxAmount: row.taxAmount,
      poNumber: row.poNumber,
      grnItemId: row.grnItemId,

    });
  }

      // Add payment if not already added
      const existingPayment = entry.payments.find(p => p.payableId === row.payableId);
      if (!existingPayment) {
        entry.payments.push({
          payableId: row.payableId,
          payment: row.paidAmount,
          status: row.status,
          receivedDate: row.receivedDate,
        });
      }
    }


const result = Array.from(invoiceMap.values()).map(inv => {
  return {
    ...inv,
    products: Array.from(inv.products.values()) // Convert Map to array
  };
});
          if (data.length > 0) {
            return new CommonResponse(true, 0, "data retrieved successfully", result)
          } else {
            return new CommonResponse(false, 1, "No data found", [])
          }     
           }catch(err){
        throw (err);
        }
        }

        async getPayablesForRM(req: PayableFilterRequest):Promise<CommonResponse>{
            try{
            const manager = getManager();
            let query =`
            SELECT pa.id AS payableId,pa.invoice_type AS invoiceType,pa.invoice_id AS invoiceId,pa.status,pa.invoice_number AS invoiceNumber,
            pa.vendor_id,Date(pa.received_date) AS receivedDate,ri.quantity,ri.total_amount as amount,(gi.taxable_amount*0.001) as deduction,pa.final_amount AS finalAmount,
            pa.payment,s.name AS vendorName,i.indent_code AS indentCode,Date(pa.invoice_date) as invoiceDate,ri.batch_number as batch,ri.count ,ri.rm_invoice_id as  itemId,ri.grn_item_id as  grnItemId,d.defect_name as deffect,ri.type
            FROM ${appSettings.finance_db}.payables pa
            LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri ON ri.invoice_number=pa.invoice_number
            left join ${appSettings.rm_procure_db}.grn_items gi on gi.grn_item_id = ri.grn_item_id
            LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id=ri.indent_id
            LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id=pa.vendor_id
left join ${appSettings.rm_procure_db}.grn_item_defects gid on ri.defect_id = gid.grn_item__defects_id and ri.type= 'DEFECT'
left join ${appSettings.masters_db}.defect d on d.defect_id= gid.defect_id
            WHERE pa.invoice_type='RM'`
             if(req.invoiceFromDate != undefined){
            query = query+=` AND Date(pa.invoice_date) Between  '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
        }
         if(req.receivedFromDate != undefined){
            query = query+=` AND Date(pa.received_date) Between  '${req.receivedFromDate}' and '${req.receivedToDate}'`
        }
        if(req.invoiceNumber != undefined){
             query = query+=` AND pa.invoice_number='${req.invoiceNumber}'`
        }
         if(req.supplierId != undefined){
             query = query+=` AND pa.vendor_id= ${req.supplierId}`
        }
        if(req.unit) {
          query = query + ` AND gi.reweighment_bill_to = '${req.unit}'`
      }
            const data = await manager.query(query);
//             const groupedData = data.reduce((result, current) => {
//                 const { payableId, invoiceType, status, invoiceNumber, receivedDate, quantity,amount,deduction,finalAmount,payment,indentCode,vendorName,invoiceId,invoiceDate,batch} = current;
          
//                 let packingGroup = result.find(item => item.invoiceNumber === invoiceNumber);
//                 if (!packingGroup) {
//                   packingGroup = {
//                     invoiceNumber,
                    
//                     invoiceType,
//                     vendorName,
//                     invoiceId,
//                     indentCode,
//                     invoiceDate,batch,
//                     products: [],
//                     payments:[]
//                   };
//                   result.push(packingGroup);
//                 }
//           const productExists = packingGroup.products.some(p => p.payableId === payableId)
//                if (!productExists) {
//     packingGroup.products.push({
//       payableId,
//       quantity,
//       amount,
//       deduction,
//     });
//   }
//         const paymentExists = packingGroup.payments.some(p => p.receivedDate === receivedDate);
//   if (!paymentExists) {
//     packingGroup.payments.push({
//       finalAmount,
//       payment,
//       status,
//       receivedDate,
//     });
// }
//                 return result;
//               }, []);
          
               const invoiceMap = new Map<string, any>()
      
    for (const row of data) {
      const invoiceNumber = row.invoiceNumber;

      if (!invoiceMap.has(invoiceNumber)) {
        invoiceMap.set(invoiceNumber, {
          invoiceNumber: invoiceNumber,
          vendorId: row.vendor_id,
          vendorName: row.vendorName,
          invoiceDate: row.invoiceDate,
          batch:row.batch,
          indentCode:row.indentCode,
           finalAmount: row.finalAmount,
          payments: [],
          products: new Map<number, any>()
        });
      }

     const entry = invoiceMap.get(invoiceNumber);

  // ✅ Push product only if itemId not already in products Map
  if (row.itemId && !entry.products.has(row.itemId)) {
    entry.products.set(row.itemId, {
      itemId: row.itemId,
      count: row.count,
      quantity: row.quantity,
      amount: row.amount,
      deduction: row.deduction,
      taxAmount: row.taxAmount,
      poNumber: row.poNumber,
      grnItemId: row.grnItemId,

    });
  }

      // Add payment if not already added
      const existingPayment = entry.payments.find(p => p.payableId === row.payableId);
      if (!existingPayment) {
        entry.payments.push({
          payableId: row.payableId,
          payment: row.payment,
          status: row.status,
          receivedDate: row.receivedDate,
        });
      }
    }

const result = Array.from(invoiceMap.values()).map(inv => {
  return {
    ...inv,
    products: Array.from(inv.products.values()) // Convert Map to array
  };
});
              if (data.length > 0) {
                return new CommonResponse(true, 0, "data retrieved successfully", result)
              } else {
                return new CommonResponse(false, 1, "No data found", [])
              }             }catch(err){
            throw (err);
            }
            }
              async getOverDueReceivables(req:PayablesDashboardReq):Promise<CommonResponse>{
                const manager = getManager()
                try{
                let querry = `SELECT (c.total_amount) AS invoiceAmtUsd,(c.collection) AS paidAmount, (c.total_amount * c.exchange_rate) as invoiceAmt, sum((col.recieved_amt)* col.exchange_rate) as collectionInr
FROM ${appSettings.sales_db}.customer_invoice AS c
LEFT JOIN ${appSettings.sales_db}.sale_order_track AS sot  ON sot.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order AS s ON s.sale_order_id   = c.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id   = c.sale_order_id
left join ${appSettings.finance_db}.collections col on col.so_id = c.sale_order_id and col.payment_type='${CollectionPaymentTypes.EXPORT_RECEIVABLES}'
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = c.unit_id
WHERE s.status!= '${SoStatusEnum.CANCELLED}'
  AND s.so_process_type = 'MTO'
    AND sot.container_status ='${ContainerStatusEnum.SHIPPED}' and c.is_active=1`
if(req.unitId != undefined){
    querry = querry+=` AND c.unit_id = '${req.unitId}'`
}
if(req.buyerId != undefined){
    querry = querry+=` AND c.end_customer_id = '${req.buyerId}'`
}
if(req.fromDate != undefined){
    querry = querry+=` AND date(c.invoice_date) between '${req.fromDate}' and '${req.toDate}'`
}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
querry = querry+=`group by c.invoice_number `
const response = await manager.query(querry)
if(response.length>0){
  const totalDueAmount = response.reduce((sum, invoice) => {
                return sum + ((Number(invoice.invoiceAmtUsd)-Number(invoice.paidAmount)) || 0);
            }, 0);
 const totalPaidAmount = response.reduce((sum, invoice) => {
                return sum + (Number(invoice.paidAmount) || 0);
            }, 0);
 const totalCollectionInr = response.reduce((sum, invoice) => {
                return sum + (Number(invoice.collectionInr) || 0);
            }, 0);
             const totalAmountUsd = response.reduce((sum, invoice) => {
                return sum + (Number(invoice.invoiceAmtUsd) || 0);
            }, 0);
            const totalInv = response.reduce((sum, invoice) => {
                return sum + (Number(invoice.invoiceAmt) || 0);
            }, 0);
            // Create final response with both individual invoices and total sum
            const finalResponse = {
                invoiceAmtUsd:totalAmountUsd,
                paidAmount:totalPaidAmount,
                invoiceAmt:totalInv,
                collectionInr:totalCollectionInr
            };
    return new CommonResponse(true,1,'date retrived Successfully',[finalResponse])
}else{
    return new CommonResponse(false,0,'no data found')
}
                }catch(err){
                    throw err
                }
            }
async getOverDueReceivablesRanges(req:PayablesDashboardReq):Promise<CommonResponse>{
const manager = getManager()
    try{
          let toDate 
    if(req.toDate != undefined||null){
    toDate = req.toDate       
    }else{
    toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate

if (req.fromDate!= undefined||null) {
  fromDate = req.fromDate
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
let querry = `SELECT  (c.total_amount) AS invoiceAmount,
  (c.collection) AS paidAmount,((c.total_amount)- (c.collection)) AS dueAmount,DATEDIFF(DATE('${toDate}'), c.invoice_date) AS aging, DATE_FORMAT(c.invoice_date, '%Y-%m-%d')as invoiceDate
FROM ${appSettings.sales_db}.customer_invoice AS c
LEFT JOIN ${appSettings.sales_db}.sale_order_track AS sot  ON sot.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order AS s ON s.sale_order_id   = c.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id   = c.sale_order_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = c.unit_id
left join ${appSettings.finance_db}.collections col on col.so_id = c.sale_order_id and col.payment_type='${CollectionPaymentTypes.EXPORT_RECEIVABLES}'
WHERE s.status!= '${SoStatusEnum.CANCELLED}'
  AND s.so_process_type = 'MTO'
    AND sot.container_status ='${ContainerStatusEnum.SHIPPED}' and c.is_active=1`
if(req.unitId != undefined){
    querry = querry+=` AND c.unit_id = '${req.unitId}'`
}
if(req.fromDate != undefined){
    querry = querry+=` AND date(c.invoice_date) between '${fromDate}' and '${toDate}'`
}
if(req.buyerId != undefined){
    querry = querry+=` AND c.end_customer_id = '${req.buyerId}'`
}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
querry = querry+=` GROUP BY c.invoice_number
HAVING (SUM(c.total_amount) - SUM(c.collection)) > 0;`
const response = await manager.query(querry)
// if(response.length>0){
//     let result = []
// const ranges = [
//     { range: '0-30',    sum: 0 ,fromDate: undefined,toDate:undefined},
//     { range: '30-90',   sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '90-150',  sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '150-180', sum: 0,fromDate: undefined,toDate:undefined},
//     { range: 'above 180', sum: 0,fromDate: undefined,toDate:undefined},
//   ];    
//       const toDateMoment = moment(toDate);
 
//   for (const res of response) {
//         const aging = Number(res.aging); 
//         const dueAmount = Number(res.dueAmount); 

//         for (const val of ranges) {
//           if (val.range === 'above 180') {
//             val.fromDate = ''; // unknown past date (can be kept as null or undefined)
//             val.toDate = toDateMoment.clone().subtract(181, 'days').format('YYYY-MM-DD');
//             if (aging >= 180) {
//               val.sum += dueAmount;
//               break;
//             }
//           } else {
//             const [min, max] = val.range.split('-').map(Number); 
//             val.fromDate = toDateMoment.clone().subtract(max, 'days').format('YYYY-MM-DD');
//            val.toDate   = toDateMoment.clone().subtract(min, 'days').format('YYYY-MM-DD');
//             if (aging >= min && aging < max) {
//               val.sum += dueAmount;
//               break;
//             }
//           }
//         }
//       }
//     return new CommonResponse(true,1,'date retrived Successfully',ranges)
// }else{
//     return new CommonResponse(false,0,'no data found')
// }
 if (response.length > 0) {
     const fromDateObj = new Date(req.fromDate);
        const toDateObj = new Date(req.toDate);
  
        const formatDate = (date: Date) => date.toISOString().split('T')[0];
        const addDays = (date: Date, days: number) => {
          const result = new Date(date);
          result.setDate(result.getDate() + days);
          return result;
        };
  
        const getClippedRange = (start: Date, end: Date) => {
          const clippedStart = start < fromDateObj ? fromDateObj : start;
          const clippedEnd = end > toDateObj ? toDateObj : end;
          return clippedStart <= clippedEnd ? [clippedStart, clippedEnd] : [null, null];
        };
  
    const today = new Date();
    const subtractDays = (days: number): string => {
      const date = new Date(req.toDate);
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    };
//  const rawRanges = [
//           { range: '0-30', startOffset: -29, endOffset: 0 },
//           { range: '30-90', startOffset: -89, endOffset: -30 },
//           { range: '90-150', startOffset: -149, endOffset: -90 },
//           { range: '150-180', startOffset: -179, endOffset: -150 },
//           { range: 'above 80', startOffset: -10000, endOffset: -180 }
//         ];
    const agingRanges = [
      { range: '0-30', from: subtractDays(30), to: subtractDays(0), sum: 0, dates: [] as string[] },
      { range: '30-90', from: subtractDays(90), to: subtractDays(31), sum: 0, dates: [] as string[] },
      { range: '90-150', from: subtractDays(150), to: subtractDays(91), sum: 0, dates: [] as string[] },
      { range: '150-180', from: subtractDays(180), to: subtractDays(151), sum: 0, dates: [] as string[] },
      { range: 'above 180', from: '', to: subtractDays(181), sum: 0, dates: [] as string[] },
    ];
//   const ranges = rawRanges.map(r => {
//           const rawStart = addDays(toDateObj, r.startOffset);
//           const rawEnd = addDays(toDateObj, r.endOffset);
//           const [start, end] = getClippedRange(rawStart, rawEnd);
//           return {
//             range: r.range,
//             from: start ? formatDate(start) : null,
//             to: end ? formatDate(end) : null,
//             sum: 0
//           };
//         });
//          for (const res of response) {
//           const invoiceDate = res.invoiceDate;
//           const dueAmount = Number(res.dueAmount);
  
//           for (const r of ranges) {
//             if (r.from && r.to && invoiceDate >= r.from && invoiceDate <= r.to) {
//               r.sum += dueAmount;
//               break;
//             }
//           }
//         }
    for (const res of response) {
      const dueAmount = Number(res.dueAmount);
      const invoiceDate = new Date(res.invoiceDate).toISOString().split('T')[0];

      for (const val of agingRanges) {
        if (val.range === 'above 180') {
          if (invoiceDate < val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        } else {
          if (invoiceDate >= val.from && invoiceDate <= val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        }
      }
    }

    const result = agingRanges.map((val) => {
      if (val.dates.length > 0) {
        const sortedDates = val.dates.sort();
        return {
          range: val.range,
          sum: val.sum,
          fromDate: sortedDates[0],
          toDate: sortedDates[sortedDates.length - 1],
        };
      } else {
        return {
          range: val.range,
          sum: 0,
          fromDate: null,
          toDate: null,
        };
      }
    });
// const result = ranges.map(r => ({
//           range: r.range,
//           sum: r.sum,
//           fromDate: r.sum > 0 ? r.from : null,
//           toDate: r.sum > 0 ? r.to : null
//         }));
    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  } else {
        return new CommonResponse(false, 0, 'No data found');
      }
                }catch(err){
                    throw err
                }
            }

async getTotalReciveableInvoices(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
                const manager = getManager()
let querry =`SELECT ec.end_customer_name as customerName,inv_num as invoiceNumber,SUM(ci.total_amount) as invoiceAmount,SUM(recieved_amt) as payment,received_date as receivedDate,transaction_type as Status,c.buyer_id ,
so_id,bank_id,ci.invoice_date as invoiceDate
 FROM ${appSettings.finance_db}.collections c
 LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id=buyer_id
 LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON c.so_id = ci.sale_order_id and ci.is_active=1
     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id
    WHERE transaction_type IS NOT NULL
`
if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if(req.buyerId != undefined){
    querry = querry+=` AND c.buyer_id = '${req.buyerId}'`
}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
    querry += ` GROUP BY inv_num,ec.end_customer_name`; 

const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getOverDueReceivablesinvoices(req:PayablesDashboardReq): Promise<CommonResponse> {
  const manager = getManager();
  try {
    
    let query = `SELECT SUM(c.total_amount) AS invoiceAmount,c.invoice_date as invoiceDate, c.invoice_number AS invoiceNumber, ec.end_customer_name AS customer,
  SUM(c.collection) AS paidAmount, (SUM(c.total_amount) - SUM(c.collection)) AS dueAmount, DATEDIFF(DATE('${req.toDate}'), c.invoice_date) AS aging
FROM ${appSettings.sales_db}.customer_invoice AS c
LEFT JOIN ${appSettings.sales_db}.sale_order_track AS sot ON sot.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items AS soi ON soi.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order AS s ON s.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = c.sale_order_id
LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = c.end_customer_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = c.unit_id

WHERE s.status != '${SoStatusEnum.CANCELLED}'
  AND s.so_process_type = 'MTO'
  AND sot.container_status = '${ContainerStatusEnum.SHIPPED}' and c.is_active=1`;

    if (req.unitId !== undefined) {
      query += ` AND c.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      query += ` AND DATE(c.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if(req.buyerId != undefined){
    query = query+=` AND c.end_customer_id = '${req.buyerId}'`
}
if(req.company != undefined){
    query = query+=` AND uc.company_id = '${req.company}'`
}
    query += ` GROUP BY c.invoice_number
               HAVING (SUM(c.total_amount) - SUM(c.collection)) > 0;`; 

    const response = await manager.query(query);
    return new CommonResponse(true, 1, 'Data retrieved successfully', response); 
  } catch (err) {
    throw err;
  }
}
async getTotalIncentiveAmount(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
        const manager = getManager()
        let ddbQuerry =`SELECT SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS totalAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' and ci.is_active=1`

let igstQuerry =`SELECT ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS totalAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST'and ci.is_active=1 `

let rodtepQuerry =`SELECT   SUM( CASE WHEN cl.received_amt_inr != 0 THEN cl.received_amt_inr ELSE
    LEAST(
      0.033 
      * ci.exchange_rate 
      * (ci.total_amount - ci.freight_charges),
      42
      *     ( CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty *0.454 ELSE soi.invoiced_qty END)

    ) END
  ) AS totalAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
  LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

 WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' and ci.is_active=1`
 if (req.unitId !== undefined) {
      ddbQuerry += ` AND ci.unit_id = '${req.unitId}'`; 
      igstQuerry += ` AND ci.unit_id = '${req.unitId}'`;
      rodtepQuerry += ` AND ci.unit_id = '${req.unitId}'`; 

    }
    if (req.fromDate !== undefined) {
      ddbQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      igstQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      rodtepQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;

    }
    if(req.buyerId != undefined){
    ddbQuerry = ddbQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    igstQuerry = igstQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    rodtepQuerry = rodtepQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    ddbQuerry = ddbQuerry+=` AND uc.company_id = '${req.company}'`
    igstQuerry = igstQuerry+=` AND uc.company_id = '${req.company}'`
    rodtepQuerry = rodtepQuerry+=` AND uc.company_id = '${req.company}'`
}
 const querry = `${ddbQuerry} UNION ALL ${igstQuerry} UNION ALL ${rodtepQuerry}`
const response = await manager.query(querry)
let total =[]
if(response.length>0){
    let amount=0
    for(const val of response){
        amount = Number(amount) + Number(val.totalAmount)
    }
    total.push({totalAmount: amount})
    return new CommonResponse(true,1,'data retrived successfully',total)
}else{
    return new CommonResponse(false,0,'No data found',total)
}
    }catch(err){
        throw err
    }
}
async getTotalReceivedIncentiveAmount(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
    const manager = getManager()
let ddbQuerry =`SELECT SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS totalAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND (ci.ddb_amt != 0 OR ci.ddb_amt != NULL) and ci.is_active=1`
let igstQuerry =`SELECT ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS totalAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' 
AND (ci.igst_amt != 0 OR ci.igst_amt != NULL) and ci.is_active=1`

let rodtepQuerry =`
SELECT SUM(sale_amount) AS totalAmount
FROM (
  SELECT DISTINCT liscence_no, sale_amount,collection_id
  FROM ${appSettings.finance_db}.rodtep  
) AS ul
LEFT JOIN ${appSettings.finance_db}.collections c ON c.id = ul.collection_id
LEFT JOIN ${appSettings.sales_db}.customer_invoice ci ON c.so_id = ci.sale_order_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE (ci.rodtep_status ='RECEIVED' OR ci.rodtep_status ='SOLD') and ci.is_active=1`
 if (req.unitId !== undefined) {
      ddbQuerry += ` AND ci.unit_id = '${req.unitId}'`; 
      igstQuerry += ` AND ci.unit_id = '${req.unitId}'`;
      rodtepQuerry += ` AND ci.unit_id = '${req.unitId}'`; 

    }
    if (req.fromDate !== undefined) {
      ddbQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      igstQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      rodtepQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;

    }
     if(req.buyerId != undefined){
    ddbQuerry = ddbQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    igstQuerry = igstQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    rodtepQuerry = rodtepQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    ddbQuerry = ddbQuerry+=` AND uc.company_id = '${req.company}'`
    igstQuerry = igstQuerry+=` AND uc.company_id = '${req.company}'`
    rodtepQuerry = rodtepQuerry+=` AND uc.company_id = '${req.company}'`
}
const receivedQuerry = `${ddbQuerry} UNION ALL ${igstQuerry} UNION ALL ${rodtepQuerry}`
const response = await manager.query(receivedQuerry)
let total =[]

if(response.length>0){
    let amount=0
    for(const val of response){
        amount = Number(amount) + Number(val.totalAmount)
    }
    total.push({totalAmount: amount})
    return new CommonResponse(true,1,'data retrived successfully',total)
}else{
    return new CommonResponse(false,0,'No data found',total)
}
    }catch(err){
        throw err
    }
}
async getTotalOverDueIncentiveAmount(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
    const manager = getManager()
let ddbQuerry =`SELECT SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND (ci.ddb_amt = 0 OR ci.ddb_amt = NULL) and ci.is_active=1`
let igstQuerry =`SELECT ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' 
AND (ci.igst_amt = 0 OR ci.igst_amt = NULL) and ci.is_active=1`
let rodtepQuerry =`SELECT  SUM(
    LEAST(
      0.033 
      * ci.exchange_rate 
      * (ci.total_amount - ci.freight_charges),
      42
      * (CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty *0.454 ELSE soi.invoiced_qty END)

    )
  ) AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
   LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

 WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}' 
 OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1`
  if (req.unitId !== undefined) {
      ddbQuerry += ` AND ci.unit_id = '${req.unitId}'`; 
      igstQuerry += ` AND ci.unit_id = '${req.unitId}'`;
      rodtepQuerry += ` AND ci.unit_id = '${req.unitId}'`; 

    }
    if (req.fromDate !== undefined) {
      ddbQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      igstQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      rodtepQuerry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;

    }
       if(req.buyerId != undefined){
    ddbQuerry = ddbQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    igstQuerry = igstQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`
    rodtepQuerry = rodtepQuerry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    ddbQuerry = ddbQuerry+=` AND uc.company_id = '${req.company}'`
    igstQuerry = igstQuerry+=` AND uc.company_id = '${req.company}'`
    rodtepQuerry = rodtepQuerry+=` AND uc.company_id = '${req.company}'`
}
const dueQuerry = `${ddbQuerry} UNION ALL ${igstQuerry} UNION ALL ${rodtepQuerry}`
const response = await manager.query(dueQuerry)
let total =[]
if(response.length>0){
    let amount=0
    for(const val of response){
        amount = Number(amount) + Number(val.totalDueAmount)
    }
    total.push({totalDueAmount: amount})
    return new CommonResponse(true,1,'data retrived successfully',total)
}else{
    return new CommonResponse(false,0,'No data found',total)
}
    }catch(err){
        throw err
    }
}
async getTotalRodtepDueIncentive(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
                const manager = getManager()
let querry =`SELECT  SUM(
   LEAST(
      0.033
      * ci.exchange_rate
      * (ci.total_amount - ci.freight_charges),
      42
      *
     ( CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty *0.454 ELSE soi.invoiced_qty END)
    )
  )   AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
  LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
       LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

 WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}' 
 OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1`
  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
     
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
         if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getTotalDdbDueIncentive(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
        
                const manager = getManager()
let querry =`SELECT SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND (ci.ddb_amt = 0 OR ci.ddb_amt = NULL) and ci.is_active=1
`
  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
     
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getTotalIgstDueIncentive(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
                const manager = getManager()
let querry =`SELECT ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS totalDueAmount FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
  LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' 
AND (ci.igst_amt = 0 OR ci.igst_amt = NULL) and ci.is_active=1`
  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
     
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}

async getRodtepDueRanges(req: PayablesDashboardReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      let querry = `
       SELECT   SUM(
    LEAST(
      0.033
      * ci.exchange_rate
      * (ci.total_amount - ci.freight_charges),
      42
      * 
     ( CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty *0.454 ELSE soi.invoiced_qty END)
    )
  )  AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging , DATE_FORMAT(ci.invoice_date, '%Y-%m-%d')as invoiceDate FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
  LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

 WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}' 
 OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1
      `;
  
      if (req.unitId !== undefined) {
        querry += ` AND ci.unit_id = '${req.unitId}'`; 
       
      }
      if (req.fromDate !== undefined) {
        querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
                 if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
  querry = querry+` GROUP by ci.sale_order_id`
  
      const response = await manager.query(querry);
  
      if (response.length > 0) {
    const today = new Date();
    const subtractDays = (days: number): string => {
      const date = new Date(req.toDate);
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    };

    const agingRanges = [
      { range: '0-60', from: subtractDays(60), to: subtractDays(0), sum: 0, dates: [] as string[] },
      { range: '60-120', from: subtractDays(120), to: subtractDays(61), sum: 0, dates: [] as string[] },
      { range: '120-150', from: subtractDays(150), to: subtractDays(121), sum: 0, dates: [] as string[] },
      { range: '150-180', from: subtractDays(180), to: subtractDays(151), sum: 0, dates: [] as string[] },
       { range: 'above 180', from: '', to: subtractDays(181), sum: 0, dates: [] as string[] },
    ];

    for (const res of response) {
      const dueAmount = Number(res.dueAmount);
      const invoiceDate = new Date(res.invoiceDate).toISOString().split('T')[0];

      for (const val of agingRanges) {
        if (val.range === 'above 180') {
          if (invoiceDate < val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        } else {
          if (invoiceDate >= val.from && invoiceDate <= val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        }
      }
    }

    const result = agingRanges.map((val) => {
      if (val.dates.length > 0) {
        const sortedDates = val.dates.sort();
        return {
          range: val.range,
          sum: val.sum,
          fromDate: sortedDates[0],
          toDate: sortedDates[sortedDates.length - 1],
        };
      } else {
        return {
          range: val.range,
          sum: 0,
          fromDate: null,
          toDate: null,
        };
      }
    });

    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  }else {
        return new CommonResponse(false, 0, 'No data found');
      }
    } catch (err) {
      console.error('Error in getRodtepDueRanges:', err);
      throw err;
    }
  }
// async getRodtepDueRanges(req: PayablesDashboardReq): Promise<CommonResponse> {
//   try {
//     const manager = getManager();
//     const toDate = req.toDate ?? moment().format('YYYY-MM-DD');
//     const fromDate = req.fromDate;

//     let query = `
//       SELECT SUM(
//         LEAST(
//           0.033 * ci.exchange_rate * (ci.total_amount - ci.freight_charges),
//           42 * (CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty * 0.454 ELSE soi.invoiced_qty END)
//         )
//       ) AS dueAmount,
//       DATEDIFF(DATE('${toDate}'), ci.invoice_date) AS aging,
//       DATE_FORMAT(ci.invoice_date, '%Y-%m-%d') AS invoiceDate
//       FROM ${appSettings.sales_db}.customer_invoice ci
//       LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
//       LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
//       LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
//       LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
//       LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
//       LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
//       WHERE sot.container_status = 'SHIPPED' 
//         AND so_status != 'CANCELLED' 
//         AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}' 
//              OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1
//     `;

//     if (req.unitId !== undefined) {
//       query += ` AND ci.unit_id = '${req.unitId}'`;
//     }

//     if (fromDate !== undefined) {
//       query += ` AND DATE(ci.invoice_date) BETWEEN '${fromDate}' AND '${toDate}'`;
//     }

//     query += ` GROUP BY ci.sale_order_id`;

//     const response = await manager.query(query);

//     const toMoment = moment(toDate);
//     const fromMoment = moment(fromDate);

//     const ranges = [
//       { label: '0-30', min: 0, max: 30 },
//       { label: '30-90', min: 31, max: 90 },
//       { label: '90-150', min: 91, max: 150 },
//       { label: '150-180', min: 151, max: 180 },
//       { label: 'above 180', min: 181, max: 10000 },
//     ];

//     const rangeDateWindows = ranges.map((range) => {
//       const start = moment(toDate).subtract(range.max, 'days');
//       const end = moment(toDate).subtract(range.min, 'days');

//       // Clamp to within requested fromDate and toDate
//       const clampedStart = moment.max(start, fromMoment);
//       const clampedEnd = moment.min(end, toMoment);

//       return {
//         label: range.label,
//         min: range.min,
//         max: range.max,
//         sum: 0,
//         startDate: clampedStart.format('YYYY-MM-DD'),
//         endDate: clampedEnd.isBefore(clampedStart) ? clampedStart.format('YYYY-MM-DD') : clampedEnd.format('YYYY-MM-DD'),
//       };
//     });

//     for (const res of response) {
//       const aging = Number(res.aging);
//       const dueAmount = Number(res.dueAmount);

//       for (const bucket of rangeDateWindows) {
//         if (
//           (bucket.label === 'above 180' && aging > 180) ||
//           (aging >= bucket.min && aging <= bucket.max)
//         ) {
//           bucket.sum += dueAmount;
//           break;
//         }
//       }
//     }

//     const result = rangeDateWindows.map((r) => ({
//       range: r.label,
//       sum: r.sum,
//       fromDate: r.startDate,
//       toDate: r.endDate,
//     }));

//     return new CommonResponse(true, 1, 'Data retrieved successfully', result);
//   } catch (err) {
//     throw err;
//   }
// }


async getDdbDueRanges(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
        const manager = getManager()
       let toDate 
    if(req.toDate != undefined||null){
    toDate = req.toDate       
    }else{
    toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate

if (req.fromDate!= undefined||null) {
  fromDate = req.fromDate
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
        let querry=`SELECT SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging, DATE_FORMAT(ci.invoice_date, '%Y-%m-%d')as invoiceDate
 FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND (ci.ddb_amt = 0 OR ci.ddb_amt = NULL) and ci.is_active=1`

  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
     
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
      querry += ` GROUP BY ci.sale_order_id`
const response = await manager.query(querry)

// if(response.length>0){
//     let result = []
//     const ranges = [
//     { range: '0-30',    sum: 0 ,fromDate: undefined,toDate:undefined},
//     { range: '30-90',   sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '90-150',  sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '150-180', sum: 0,fromDate: undefined,toDate:undefined},
//     { range: 'above 180', sum: 0,fromDate: undefined,toDate:undefined},
//   ];    
//   const toDateMoment = moment(toDate);
//   for (const res of response) {
//         const aging = Number(res.aging); 
//         const dueAmount = Number(res.dueAmount); 

//         for (const val of ranges) {
//           if (val.range === 'above 180') {
//             // const toDate =
//             val.fromDate = ''; // unknown past date (can be kept as null or undefined)
//             val.toDate = toDateMoment?.clone().subtract(181, 'days').format('DD-MM-YYYY');
//             if (aging >= 180) {
//               val.sum += dueAmount;
//               break;
//             }
//           } else {
//             const [min, max] = val.range.split('-').map(Number); 
//             val.fromDate = toDateMoment.clone().subtract(max, 'days').format('YYYY-MM-DD');
//            val.toDate   = toDateMoment.clone().subtract(min, 'days').format('YYYY-MM-DD');
//             if (aging >= min && aging < max) {
//                 console.log(aging,'iiiii');
                
//               val.sum += dueAmount;
//               break;
//             }
//           }
//         }
//       }
//     return new CommonResponse(true,1,'date retrived Successfully',ranges)
// }else{
//     return new CommonResponse(false,0,'no data found')
// }
if (response.length > 0) {
    const today = new Date();
    const subtractDays = (days: number): string => {
      const date = new Date(req.toDate);
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    };

   const agingRanges = [
      { range: '0-60', from: subtractDays(60), to: subtractDays(0), sum: 0, dates: [] as string[] },
      { range: '60-120', from: subtractDays(120), to: subtractDays(61), sum: 0, dates: [] as string[] },
      { range: '120-150', from: subtractDays(150), to: subtractDays(121), sum: 0, dates: [] as string[] },
      { range: '150-180', from: subtractDays(180), to: subtractDays(151), sum: 0, dates: [] as string[] },
       { range: 'above 180', from: '', to: subtractDays(181), sum: 0, dates: [] as string[] },
    ];


    for (const res of response) {
      const dueAmount = Number(res.dueAmount);
      const invoiceDate = new Date(res.invoiceDate).toISOString().split('T')[0];

      for (const val of agingRanges) {
        if (val.range === 'above 180') {
          if (invoiceDate < val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        } else {
          if (invoiceDate >= val.from && invoiceDate <= val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        }
      }
    }

    const result = agingRanges.map((val) => {
      if (val.dates.length > 0) {
        const sortedDates = val.dates.sort();
        return {
          range: val.range,
          sum: val.sum,
          fromDate: sortedDates[0],
          toDate: sortedDates[sortedDates.length - 1],
        };
      } else {
        return {
          range: val.range,
          sum: 0,
          fromDate: null,
          toDate: null,
        };
      }
    });

    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  } else {
        return new CommonResponse(false, 0, 'No data found');
      }
    }catch(err){
        throw err
    }
}
async getIgstDueRangess(req:PayablesDashboardReq):Promise<CommonResponse> {
    
    try{
                const manager = getManager()
                        let toDate 
    if(req.toDate != undefined||null){
    toDate = req.toDate       
    }else{
    toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate

if (req.fromDate!= undefined||null) {
  fromDate = req.fromDate
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
let querry =`SELECT ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging , DATE_FORMAT(ci.invoice_date, '%Y-%m-%d')as invoiceDate
FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
     LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' 
AND (ci.igst_amt = 0 OR ci.igst_amt = NULL) and ci.is_active=1`
  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
       querry += ` GROUP BY ci.sale_order_id`

const response = await manager.query(querry)
// if(response.length>0){
//     let result = []
// const ranges = [
//     { range: '0-30',    sum: 0 ,fromDate: undefined,toDate:undefined},
//     { range: '30-90',   sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '90-150',  sum: 0,fromDate: undefined,toDate:undefined},
//     { range: '150-180', sum: 0,fromDate: undefined,toDate:undefined},
//     { range: 'above 180', sum: 0,fromDate: undefined,toDate:undefined},
//   ];   
//     const toDateMoment = moment(toDate);
 
//   for (const res of response) {
//         const aging = Number(res.aging); 
//         const dueAmount = Number(res.dueAmount); 

//         for (const val of ranges) {
//           if (val.range === 'above 180') {
//             val.fromDate = ''; // unknown past date (can be kept as null or undefined)
//             val.toDate = toDateMoment.clone().subtract(181, 'days').format('YYYY-MM-DD');
//             if (aging >= 180) {
//               val.sum += dueAmount;
//               break;
//             }
//           } else {
//             const [min, max] = val.range.split('-').map(Number); 
//             val.fromDate = toDateMoment.clone().subtract(max, 'days').format('YYYY-MM-DD');
//            val.toDate   = toDateMoment.clone().subtract(min, 'days').format('YYYY-MM-DD');
//             if (aging >= min && aging < max) {
//               val.sum += dueAmount;
//               break;
//             }
//           }
//         }
//       }
//     return new CommonResponse(true,1,'date retrived Successfully',ranges)
// }else{
//     return new CommonResponse(false,0,'no data found')
// }
 if (response.length > 0) {
    const today = new Date();
    const subtractDays = (days: number): string => {
      const date = new Date(req.toDate);
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    };

   const agingRanges = [
      { range: '0-60', from: subtractDays(60), to: subtractDays(0), sum: 0, dates: [] as string[] },
      { range: '60-120', from: subtractDays(120), to: subtractDays(61), sum: 0, dates: [] as string[] },
      { range: '120-150', from: subtractDays(150), to: subtractDays(121), sum: 0, dates: [] as string[] },
      { range: '150-180', from: subtractDays(180), to: subtractDays(151), sum: 0, dates: [] as string[] },
       { range: 'above 180', from: '', to: subtractDays(181), sum: 0, dates: [] as string[] },
    ];


    for (const res of response) {
      const dueAmount = Number(res.dueAmount);
      const invoiceDate = new Date(res.invoiceDate).toISOString().split('T')[0];

      for (const val of agingRanges) {
        if (val.range === 'above 180') {
          if (invoiceDate < val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        } else {
          if (invoiceDate >= val.from && invoiceDate <= val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        }
      }
    }

    const result = agingRanges.map((val) => {
      if (val.dates.length > 0) {
        const sortedDates = val.dates.sort();
        return {
          range: val.range,
          sum: val.sum,
          fromDate: sortedDates[0],
          toDate: sortedDates[sortedDates.length - 1],
        };
      } else {
        return {
          range: val.range,
          sum: 0,
          fromDate: null,
          toDate: null,
        };
      }
    });

    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  } else {
        return new CommonResponse(false, 0, 'No data found');
      }
    }catch(err){
        throw err
    }
}
async getRodtepDueInvoices(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
        
                const manager = getManager()
     let toDate 
    if(req.toDate != undefined||null){
 toDate = moment(req.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD')        
}else{
            toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate: string | undefined;

if (req.fromDate!= undefined||null) {
  fromDate = moment(req.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
let querry =`SELECT  ec.end_customer_name AS customerName,ci.invoice_number AS invoiceNumber, SUM(
    LEAST(
      0.033
      * ci.exchange_rate
      * (ci.total_amount - ci.freight_charges),
      42
      * 
     ( CASE WHEN (u.uom_name = 'LBS' OR u.uom_name = 'OZ') THEN soi.invoiced_qty *0.454 ELSE soi.invoiced_qty END)
    )
  ) AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging,DATE(ci.invoice_date) AS invoiceDate  FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.finance_db}.collections cl ON cl.so_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
  LEFT JOIN ${appSettings.masters_db}.uoms u ON u.uom_id = soi.uom_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

 WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND (ci.rodtep_status = '${RodtepStatus.PAYMENT_NOT_RECEIVED_AND_ICE_GATE_NOT_UPDATED}'  
 OR ci.rodtep_status = '${RodtepStatus.PAYMENT_RECEIVED_AND_BRC_UPDATED}') and ci.is_active=1`
  if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
             querry += ` GROUP BY ci.invoice_number`

const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getDdbDueInvoices(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
    const manager = getManager()
      let toDate 
    if(req.toDate != undefined||null){
 toDate = moment(req.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD')        
}else{
            toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate: string | undefined;

if (req.fromDate!= undefined||null) {
  fromDate = moment(req.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
        
        let querry=`SELECT ec.end_customer_name AS customerName,ci.invoice_number AS invoiceNumber,DATE(ci.invoice_date) AS invoiceDate,SUM(((ci.total_amount - ci.freight_charges) * 0.033) * ci.exchange_rate) AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging,DATE(ci.invoice_date) AS invoiceDate
 FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND mode_of_export != 'FLIGHT' AND (ci.ddb_amt = 0 OR ci.ddb_amt = NULL) and ci.is_active=1`
if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
             querry += ` GROUP BY ci.invoice_number`
             const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getIgstDueInvoices(req:PayablesDashboardReq):Promise<CommonResponse> {
    try{
        
                const manager = getManager()
                  let toDate 
    if(req.toDate != undefined||null){
 toDate = moment(req.toDate, 'DD-MM-YYYY').format('YYYY-MM-DD')        
}else{
            toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate: string | undefined;

if (req.fromDate!= undefined||null) {
  fromDate = moment(req.fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
let querry =`SELECT ec.end_customer_name AS customerName,ci.invoice_number AS invoiceNumber,ROUND(SUM((t.tax_percentage*soi.inv_amount*ci.exchange_rate)/100), 2) AS dueAmount,DATEDIFF(DATE('${req.toDate}'), ci.invoice_date) AS aging ,DATE(ci.invoice_date) AS invoiceDate
FROM ${appSettings.sales_db}.customer_invoice ci 
LEFT JOIN ${appSettings.sales_db}.sale_order_track sot ON sot.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.logistics_db}.container co ON co.sale_order_id = ci.sale_order_id
LEFT JOIN ${appSettings.sales_db}.sale_order_items soi ON soi.sale_order_id = ci.sale_order_id
 LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = soi.tax_id
 LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = ci.end_customer_id
       LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = ci.unit_id

WHERE sot.container_status ='SHIPPED' AND so_status != 'CANCELLED' AND ci.is_tax_applicable = 'YES' AND ci.invoice_category = 'IGST' 
AND (ci.igst_amt = 0 OR ci.igst_amt = NULL) and ci.is_active=1`

if (req.unitId !== undefined) {
      querry += ` AND ci.unit_id = '${req.unitId}'`; 
    }
    if (req.fromDate !== undefined) {
      querry += ` AND DATE(ci.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
      }
               if(req.buyerId != undefined){
    querry = querry+=` AND ci.end_customer_id = '${req.buyerId}'`

}
if(req.company != undefined){
    querry = querry+=` AND uc.company_id = '${req.company}'`
}
             querry += ` GROUP BY ci.invoice_number`

const response = await manager.query(querry)

        return new CommonResponse(true,1,'data retrived successfully',response)
    }catch(err){
        throw err
    }
}
async getRMDueAmountData(req:PayablesDashboardReq):Promise<CommonResponse>{
    try{
        console.log(req,'request!!!!!!!!!!!!!!')
      const manager = getManager();
    //   let query1

        // let query=''

        // if(req.fromDate && req.toDate){
        //     console.log('ooooooooo');
            
        //     query  +=  query+` and date(rmi.invoice_date) BETWEEN '${req.fromDate}' and '${req.toDate}'`
        // }
        // if(req.company != undefined){
        //     query = query+ ` and uc.company_id=${req.company}`
        // }
        //  if(req.unitId != undefined){
        //     query = query+ ` and rmi.plant_id=${req.unitId}`
        // }
        // if(req.supplierId != undefined){
        //     query = query+` and sf.supplier_id = ${req.supplierId}`
        // }
        // if(req.noOfDays != undefined  && req.model === 'COUNT'){
        //     query += query+` and date(invoice_date) BETWEEN '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
        //     // console.log('cmae hereee')
            //   if(Number(req.noOfDays) === 10){
            //     // console.log(' came  heree 10 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 0 AND 10`
            // }
            //  if(Number(req.noOfDays) === 20){
            //     // console.log(req.noOfDays ,'20 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 10 AND 20`
            // }
            // if(Number(req.noOfDays) === 30){
            //     // console.log(req.noOfDays ,'30 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 20 AND 30`
            // }
            //   if(Number(req.noOfDays) === 40){
            //     // console.log(req.noOfDays ,'40 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 30 AND 40`
            // }
            //  if(Number(req.noOfDays) === 50){
            //     // console.log(req.noOfDays ,'50 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 40 AND 50`
            // }
            //   if(Number(req.noOfDays) === 60){
            //     // console.log(req.noOfDays ,'30 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 50 AND 60`
            // }
            //  if(Number(req.noOfDays) === 70){
            //     // console.log(req.noOfDays ,'30 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 60 AND 70`
            // }
            // if(Number(req.noOfDays) === 80){
            //     // console.log(req.noOfDays ,'80 dyas')

            //   query += query+` and  DATEDIFF('${req.invoiceToDate}',DATE(invoice_date)) BETWEEN 70 AND 80`
            // }
           
            // if(Number(req.noOfDays) > 80){
            //     // console.log(' came  heree above0 dyas')

            //     query += query+` and DATEDIFF('${req.invoiceToDate}', DATE(invoice_date)) > 80`
            // } 
        //  }

            // query1 =`  
            //        SELECT 
            //     invoice_number,  grn_item_id,tdsval,
            //     ROUND(SUM(total_amount),2) AS totalAmount,ROUND(SUM(total_amount-payment-tdsval),2) AS dueAmpount,Round(payment,2) AS paidAmount,indent_id,
            //     supplier_type AS supplierType,broker,farmer,brokerName,farmerName,invoice_date
            // FROM (
            //     SELECT DISTINCT rmi.invoice_number,invoice_date, rmi.total_amount,rmi.payment,
            //     rmi.indent_id 
            // ,i.supplier_type,
            //             gi.broker,gi.farmer,sb.name AS brokerName,sf.name AS farmerName,
            //              gi.taxable_amount,rmi.grn_item_id,COALESCE(taxable_amount *0.001,0) AS tdsval            
            //     FROM erpx_dev_rm_procurement.rm_invoice rmi
            //     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
            //     LEFT JOIN  ${appSettings.rm_procure_db}.indent i ON rmi.indent_id=i.indent_id
            //     LEFT JOIN ${appSettings.masters_db}.suppliers sb ON gi.broker =sb.supplier_id AND i.supplier_type ='DEALER'
            //     LEFT JOIN ${appSettings.masters_db}.suppliers sf ON gi.farmer =sf.supplier_id AND i.supplier_type !='DEALER'
            //            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = rmi.plant_id
            //     WHERE rm_invoice_id >0 ${ query}
            // ) AS uniq
            // GROUP BY invoice_number;`

        
       
        // query = query+ `  GROUP BY invoice_number`
          let query = `select sum(rmi.total_amount - (gi.taxable_amount * 0.001)) as invoiceAmt, sum(rmi.total_amount) as totalAmount,(rmi.payment) as paidAmount,DATEDIFF('${req.toDate}', invoice_date) as aging, invoice_number, invoice_date, gi.grn_item_id, rmi.indent_id, i.supplier_type as supplierType,b.name as brokerName, f.name as farmerName,DATE_FORMAT(rmi.invoice_date, '%Y-%m-%d')as invoice_date,sum(gi.taxable_amount * 0.001) as tdsval
    FROM erpx_dev_rm_procurement.rm_invoice rmi
    LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
    LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
 LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.farmer = b.supplier_id AND i.supplier_type ='Dealer'
 LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'
    WHERE invoice_date BETWEEN '${req.fromDate}' AND '${req.toDate}' `
    
    if(req.unitId != undefined){
        query += query+` and rmi.plant_id=${req.unitId}`
    }
    
if(req.supplierId) {
    query = query + ` AND (gi.farmer = '${req.supplierId}' OR gi.broker = '${req.supplierId}')`
}
  if(req.company != undefined){
            query = query+ ` and ucc.company='${req.company}'`
        }
    query = query+`  group by invoice_number`
    const response = await manager.query(query)
        if(response.length){
            return new CommonResponse(true,1,'Data Retrived Sucessfully',response)
        }
        else{
            return new CommonResponse(false,0,'No Data Found',[])
        }

    }catch(err){
        throw err
    }
}

async getRmPaidAmountData(req:RmDateReq):Promise<CommonResponse>{
    try{
        // console.log('@@@@@@@@@@@@@@@@@@@@@@@@')
      const manager = getManager();
      let query
         query=`SELECT rmi.invoice_number,rmi.invoice_date,SUM(total_amount) AS totalAmount,SUM(total_amount)-sum(p.amount) AS dueAmpount,rmi.payment AS paidAmount,rmi.indent_id ,i.supplier_type AS supplierType,
            gi.broker,gi.farmer,sb.name AS brokerName,sf.name AS farmerName,
            p.invoice_type as invoiceType,p.received_date as paymentRecivedDate,sum(p.amount) as paybleAmount,p.received_date, (CASE 
                                    WHEN gi.tds_applicable = 1 
                                    THEN (gi.taxable_amount * 0.001) 
                                    ELSE 0 
                                END) as deduction
            FROM erpx_dev_rm_procurement.rm_invoice rmi
            LEFT JOIN ${appSettings.rm_procure_db}.indent i ON rmi.indent_id=i.indent_id
            LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id=i.indent_id
            LEFT JOIN ${appSettings.masters_db}.suppliers sb ON ii.broker =sb.supplier_id 
            LEFT JOIN ${appSettings.masters_db}.suppliers sf ON ii.farmer =sf.supplier_id 
            LEFT JOIN ${appSettings.finance_db}.payables p on p.invoice_number = rmi.invoice_number
            LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = rmi.plant_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes ucc on ucc.company=reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'
            where p.invoice_type = 'RM'  AND p.payment IS NOT NULL
        `
        if(req.invoiceFromDate && req.invoiceToDate){
            query = query+` and date(rmi.invoice_date) BETWEEN '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
        }
        if(req.unit != undefined){
            query = query+ ` and rmi.plant_id=${req.unit}`
        }
        if(req.supplierId != undefined){
            query = query+` and sf.supplier_id = ${req.supplierId}`
        }
         if(req.company != undefined){
            query = query+ ` and ucc.company='${req.company}'`
        }
        query = query+ `  GROUP BY invoice_number`

        const response = await manager.query(query)
        if(response.length){
            return new CommonResponse(true,1,'Data Retrived Sucessfully',response)
        }
        else{
            return new CommonResponse(false,0,'No Data Found',[])
        }

    }catch(err){
        throw err
    }



}

    async getRmagingDuesData(req:PayablesDashboardReq):Promise<CommonResponse>{
        try{
            let query1 =''
            // if(req.unit != undefined){
            //     query1 += query1+` and rmi.plant_id=${req.unit}`
            // }
             let toDate 
    if(req.toDate != undefined||null){
    toDate = req.toDate       
    }else{
    toDate = moment(new Date()).format('YYYY-MM-DD')
        }
        let fromDate

if (req.fromDate!= undefined||null) {
  fromDate = req.fromDate
} else {
  fromDate = undefined; // or leave undefined if you only want to filter when it exists
}
            // let joinQuery=`LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
            // LEFT JOIN ${appSettings.rm_procure_db}.indent_items ii ON ii.indent_id = i.indent_id
            // LEFT JOIN ${appSettings.masters_db}.suppliers f ON ii.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
            // LEFT JOIN ${appSettings.masters_db}.suppliers b ON ii.farmer = b.supplier_id AND i.supplier_type ='Dealer'`
        const manager = getManager();
//         const query=`
//                         SELECT '0-10' AS aging, DATE('${req.invoiceToDate}')AS toDate, DATE_FORMAT(DATE_SUB(DATE('${req.invoiceToDate}'), INTERVAL 10 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 0 AND 10 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 0 AND 10 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         10 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}' AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 0 AND 10
//                     ${ query1}

//                     UNION ALL

//                         SELECT '10-20' AS aging, DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 11 DAY), '%Y-%m-%d') AS toDate,
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 20 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 11 AND 20 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 11 AND 20 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         20 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 10 AND 20  ${ query1}

//                     UNION ALL
//                      SELECT '20-30' AS aging,DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 21 DAY), '%Y-%m-%d') AS toDate,
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 29 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 21 AND 30 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 21 AND 30 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         30 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 20 AND 30  ${ query1}

//                     UNION ALL
//                      SELECT '30-40' AS aging,DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 31 DAY), '%Y-%m-%d') AS toDate,
//                       DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 39 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 31 AND 40 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 31 AND 40 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         40 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 31 AND 40  ${ query1}

//                     UNION ALL
//                      SELECT '40-50' AS aging,DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 40 DAY), '%Y-%m-%d') AS toDate,
//                       DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 49 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 41 AND 50 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 41 AND 50 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         50 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 41 AND 50  ${ query1}

//                     UNION ALL
//                      SELECT '50-60' AS aging, DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 51 DAY), '%Y-%m-%d') AS toDate,
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 60 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 51 AND 60 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 51 AND 60 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         60 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 51 AND 60  ${ query1}

//                     UNION ALL
//                      SELECT '60-70' AS aging,DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 61 DAY), '%Y-%m-%d') AS toDate,
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 70 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 61 AND 70 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 61 AND 70 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         70 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 61 AND 70  ${ query1}

//                     UNION ALL
//                      SELECT '70-80' AS aging,DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 71 DAY), '%Y-%m-%d') AS toDate,
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 80 DAY), '%Y-%m-%d') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 71 AND 80 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 71 AND 80 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         80 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) BETWEEN 71 AND 80  ${ query1}

//                     UNION ALL

//  SELECT 'above-80' AS aging, 
//        DATE_FORMAT(DATE_SUB('${req.invoiceToDate}', INTERVAL 81 DAY), '%Y-%m-%d') AS toDate,
//        DATE('1900-01-01') AS fromDate,
//                         CASE 
//                             WHEN 
//                             SUM(CASE 
//                                 WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) > 80 
//                                 THEN 
//                                  CASE 
//                                     WHEN gi.tds_applicable = 1 
//                                     THEN total_amount - (gi.taxable_amount * 0.001) 
//                                     ELSE total_amount 
//                                 END
//                                 ELSE 0 END) > 0
//                             THEN SUM(CASE WHEN DATEDIFF('${req.invoiceToDate}', invoice_date) > 80 THEN  CASE 
//                         WHEN gi.tds_applicable = 1 
//                         THEN total_amount - (gi.taxable_amount * 0.001) 
//                         ELSE total_amount 
//                     END ELSE 0 END) - sum(rmi.payment)
//                             ELSE 0
//                         END AS total_amount,
//                         90 AS noOfDays
//                     FROM erpx_dev_rm_procurement.rm_invoice rmi
//                     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//                     WHERE invoice_date BETWEEN '${req.invoiceFromDate}' AND '${req.invoiceToDate}'
//                     AND DATEDIFF('${req.invoiceToDate}', invoice_date) > 80  ${ query1} `

                    // const response = await manager.query(query)
let query = `
  SELECT 
    SUM(rmi.total_amount - (gi.taxable_amount * 0.001)) AS invoiceAmt,
    SUM(rmi.total_amount) AS totalAmount,
    rmi.payment AS paidAmount,
    DATEDIFF('${req.toDate}', rmi.invoice_date) AS aging,
    rmi.invoice_number,
    rmi.invoice_date,
    gi.grn_item_id,
    rmi.indent_id,
    i.supplier_type AS supplierType,
    b.name AS brokerName,
    f.name AS farmerName,
    DATE_FORMAT(rmi.invoice_date, '%Y-%m-%d') AS invoiceDate
  FROM erpx_dev_rm_procurement.rm_invoice rmi
  LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
  LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
  LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
  LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.farmer = b.supplier_id AND i.supplier_type = 'Dealer'
  LEFT JOIN ${appSettings.masters_db}.unitcodes ucc ON ucc.company = gi.reweighment_bill_to AND ucc.plant_type = 'MANUFACTURING PLANT'
  WHERE rmi.invoice_date BETWEEN '${req.fromDate}' AND '${req.toDate}'
`;

if (req.unitId !== undefined) {
  query += ` AND rmi.plant_id = ${req.unitId}`;
}

if (req.supplierId) {
  query += ` AND (gi.farmer = '${req.supplierId}' OR gi.broker = '${req.supplierId}')`;
}

if (req.company) {
  query += ` AND ucc.company = '${req.company}'`;
}

query += ` GROUP BY rmi.invoice_number`;

    const response = await manager.query(query)
    if (response.length > 0) {
     const fromDateObj = new Date(req.fromDate);
        const toDateObj = new Date(req.toDate);
  
        const formatDate = (date: Date) => date.toISOString().split('T')[0];
        const addDays = (date: Date, days: number) => {
          const result = new Date(date);
          result.setDate(result.getDate() + days);
          return result;
        };
  
        const getClippedRange = (start: Date, end: Date) => {
          const clippedStart = start < fromDateObj ? fromDateObj : start;
          const clippedEnd = end > toDateObj ? toDateObj : end;
          return clippedStart <= clippedEnd ? [clippedStart, clippedEnd] : [null, null];
        };
  
    const today = new Date();
    const subtractDays = (days: number): string => {
      const date = new Date(req.toDate);
      date.setDate(date.getDate() - days);
      return date.toISOString().split('T')[0];
    };

    const agingRanges = [
      { range: '0-10', from: subtractDays(10), to: subtractDays(0), sum: 0, dates: [] as string[] },
      { range: '10-20', from: subtractDays(20), to: subtractDays(11), sum: 0, dates: [] as string[] },
      { range: '20-30', from: subtractDays(30), to: subtractDays(21), sum: 0, dates: [] as string[] },
      { range: '30-40', from: subtractDays(40), to: subtractDays(31), sum: 0, dates: [] as string[] },
      { range: '40-50', from: subtractDays(50), to: subtractDays(41), sum: 0, dates: [] as string[] },
      { range: '50-60', from: subtractDays(60), to: subtractDays(51), sum: 0, dates: [] as string[] },
      { range: '60-70', from: subtractDays(70), to: subtractDays(61), sum: 0, dates: [] as string[] },
      { range: '70-80', from: subtractDays(80), to: subtractDays(71), sum: 0, dates: [] as string[] },
       { range: 'above 80', from: '', to: subtractDays(81), sum: 0, dates: [] as string[] },
    ];

    for (const res of response) {
      const dueAmount = Number(res.paidAmount) > 0 ? Number(res.invoiceAmt) - Number(res.paidAmount) : Number(res.invoiceAmt);
      const invoiceDate = new Date(res.invoiceDate).toISOString().split('T')[0];

      for (const val of agingRanges) {
        if (val.range === 'above 180') {
          if (invoiceDate < val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        } else {
          if (invoiceDate >= val.from && invoiceDate <= val.to) {
            val.sum += dueAmount;
            val.dates.push(invoiceDate);
            break;
          }
        }
      }
    }

    const result = agingRanges.map((val) => {
      if (val.dates.length > 0) {
        const sortedDates = val.dates.sort();
        return {
          range: val.range,
          sum: val.sum,
          fromDate: sortedDates[0],
          toDate: sortedDates[sortedDates.length - 1],
        };
      } else {
        return {
          range: val.range,
          sum: 0,
          fromDate: null,
          toDate: null,
        };
      }
    });
// const result = ranges.map(r => ({
//           range: r.range,
//           sum: r.sum,
//           fromDate: r.sum > 0 ? r.from : null,
//           toDate: r.sum > 0 ? r.to : null
//         }));
    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  } else {
        return new CommonResponse(false, 0, 'No data found');
      }

        }catch(err){
            throw err
        }

        
    }
    async getSalesTotalAmount():Promise<CommonResponse>{
        try{
            const manager = getManager();
            const query=`select sum(total_amount) as usdAmount,sum(total_amount * exchange_rate) as inrAmount from ${appSettings.sales_db}.customer_invoice where is_active=1`
            const data = await manager.query(query)
            if(data.length){
                return new CommonResponse(true,1,'Data retrived',data)
            }
        }catch(err){
            throw err
        }
    }
    async getSalesInvoiceAmount():Promise<CommonResponse>{
        try{
            const manager = getManager();
            const query=`select sum(total_amount) as usdAmount,sum(total_amount * exchange_rate) as inrAmount from ${appSettings.sales_db}.customer_invoice where is_active=1`
            const data = await manager.query(query)
            if(data.length){
                return new CommonResponse(true,1,'Data retrived',data)
            }
        }catch(err){
            throw err
        }
    }
    async getSalesNetWeight():Promise<CommonResponse>{
        try{
            const manager = getManager();
            const query=`
            SELECT SUM(kgsweight)/1000 AS kgWeight,SUM(lbweight) AS lbWeight 
            FROM
            (SELECT uom_name,si.uom_id,net_weight,
            IF(uom_name ='LBS' OR 'OZ',net_weight*0.4536 ,net_weight) AS kgsweight,
            IF(uom_name = 'KGS' OR 'GMS' ,net_weight*2.2046 ,net_weight) AS lbweight
            FROM ${appSettings.sales_db}.sale_order_items si
            LEFT JOIN ${appSettings.masters_db}.uoms u ON u. uom_id=si.uom_id)
            AS table1`
            const data = await manager.query(query)
            if(data.length){
                return new CommonResponse(true,1,'Data retrived',data)
            }
        }catch(err){
            throw err
        }
    }
        async getPayablesSuppliers(req:PayableFilterRequest):Promise<CommonResponse>{
            console.log(req,'pppppppppppppp');
        try{
        const manager = getManager();
        let query 
        if(req.type === 'PACKING'){
            query = ` SELECT pa.vendor_id as vendorId,v.vendor_name AS vendorName
        FROM ${appSettings.finance_db}.payables pa
        LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id=pa.vendor_id
        WHERE pa.invoice_type='PACKING'`
        }else{
            query = ` SELECT pa.vendor_id as vendorId,v.name AS vendorName
            FROM ${appSettings.finance_db}.payables pa
            LEFT JOIN ${appSettings.masters_db}.suppliers v ON v.supplier_id =pa.vendor_id
        WHERE pa.invoice_type='RM'`
        }
        query = query+=` group by pa.vendor_id`
        const data = await manager.query(query);
     
      
          if (data.length > 0) {
            return new CommonResponse(true, 0, "data retrieved successfully", data)
          } else {
            return new CommonResponse(false, 1, "No data found", [])
          }     
           }catch(err){
        throw (err);
        }
        }
        async getPayablesInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
        try{
        const manager = getManager();
        let query
        if(req.type=='RM'){
            query=` SELECT pa.invoice_number as invoiceNumber,ri.batch_number as batch,gi.year
        FROM ${appSettings.finance_db}.payables pa 
        left join ${appSettings.rm_procure_db}.rm_invoice ri on ri.invoice_number = pa.invoice_number
        left join ${appSettings.rm_procure_db}.grn_items gi on ri.grn_item_id = gi.grn_item_id
         WHERE 1=1 and pa.invoice_type='RM'`
           
        }else{
             query=` SELECT pa.invoice_number as invoiceNumber
        FROM ${appSettings.finance_db}.payables pa WHERE 1=1 `
           
            query = query+=`   and pa.invoice_type='PACKING'`
        }
        query = query+=` group by pa.invoice_number`
        const data = await manager.query(query);
     
      
          if (data.length > 0) {
            return new CommonResponse(true, 0, "data retrieved successfully", data)
          } else {
            return new CommonResponse(false, 1, "No data found", [])
          }     
           }catch(err){
        throw (err);
        }
        }
        async getContainerShippedSoCount(req?:RmDateReq):Promise<CommonResponse>{
            try{
                const manager = getManager();
                let query
                 query=`SELECT COUNT(s.sale_order_id) AS soCount FROM  ${appSettings.sales_db}.sale_order_track s
                left join ${appSettings.sales_db}.customer_invoice c on c.sale_order_id=s.sale_order_id
                    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = c.unit_id

                 WHERE container_status='SHIPPED' AND so_status NOT IN('CANCELLED') and c.is_active=1`
                  if(req.unit != undefined){
                    query = query+ ` and c.unit_id=${req.unit}`
                 }
                 if(req.buyerId != undefined){
                        query = query+=` AND c.end_customer_id = '${req.buyerId}'`
                    }
                 if(req.invoiceFromDate && req.invoiceToDate){
                    query=query+` and date(c.invoice_date) BETWEEN '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
                 }
                
                                
                if(req.company != undefined){
                            query = query+ ` and uc.company_id=${req.company}`
                        }              
                          const data = await manager.query(query)
                if(data.length){
                    return new CommonResponse(true,1,'Data retrived',data)
                }
            }catch(err){
                throw err
            }
        }

//   async rmDueData(req:PayablesDashboardReq):Promise<CommonResponse>{
//     try{
//         console.log(req,'request service')
//       const manager = getManager();
//       let query1

//     //     let query=''

//     //     if(req.invoiceFromDate && req.invoiceToDate){
//     //         query  +=  query+` and date(rmi.invoice_date) BETWEEN '${req.invoiceFromDate}' and '${req.invoiceToDate}'`
//     //     }
//     //     if(req.unit != undefined){
//     //         query += query+` and rmi.plant_id=${req.unit}`
//     //     }
//     //      if(req.supplierId != undefined){
//     //         query += query+` and sf.supplier_id=${req.supplierId}`
//     //     }
//     //    if(req.company != undefined){
//     //         query += query+` and uc.company_id=${req.company}`
//     //     }
//     //         query1 =`  
//     //                SELECT 
//     //             invoice_number, grn_item_id,tdsval,
//     //             ROUND(SUM(total_amount),2) AS totalAmount,ROUND(SUM(total_amount-tdsval-payment),2) AS dueAmount,ROUND(payment,2) AS paidAmount,indent_id,
//     //             supplier_type AS supplierType,broker,farmer,brokerName,farmerName,invoice_date
//     //         FROM (
//     //             SELECT DISTINCT rmi.invoice_number,invoice_date, rmi.total_amount,rmi.payment,
//     //             rmi.indent_id
//     //         ,i.supplier_type,
//     //                     gi.broker,gi.farmer,sb.name AS brokerName,sf.name AS farmerName,
//     //                     gi.taxable_amount,rmi.grn_item_id,COALESCE(taxable_amount *0.001,0) AS tdsval
//     //             FROM erpx_dev_rm_procurement.rm_invoice rmi
//     //             LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//     //             LEFT JOIN ${appSettings.rm_procure_db}.indent i ON rmi.indent_id=i.indent_id
//     //             LEFT JOIN ${appSettings.masters_db}.suppliers sb ON gi.broker =sb.supplier_id AND i.supplier_type ='DEALER'
//     //             LEFT JOIN ${appSettings.masters_db}.suppliers sf ON gi.farmer =sf.supplier_id AND i.supplier_type !='DEALER'
//     //                 LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id =rmi.plant_id

//     //             WHERE rm_invoice_id >0 ${ query}
//     //         ) AS uniq
//     //       ` 

//      let query = `select sum(rmi.total_amount - (gi.taxable_amount * 0.001)) as invoiceAmt, sum(rmi.total_amount) as totalAmount,(rmi.payment) as paidAmount,DATEDIFF('${req.toDate}', invoice_date) as aging, invoice_number, invoice_date, gi.grn_item_id, rmi.indent_id, i.supplier_type as supplierType,b.name as brokerName, f.name as farmerName,DATE_FORMAT(rmi.invoice_date, '%Y-%m-%d')as invoice_date,sum(gi.taxable_amount * 0.001) as tdsval
//     FROM erpx_dev_rm_procurement.rm_invoice rmi
//     LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
//     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
//     LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
//  LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.farmer = b.supplier_id AND i.supplier_type ='Dealer'
//  LEFT JOIN ${appSettings.masters_db}.unitcodes ucc ON ucc.company = gi.reweighment_bill_to AND ucc.plant_type='MANUFACTURING PLANT'
//     WHERE invoice_date BETWEEN '${req.fromDate}' AND '${req.toDate}' `
    
//     if(req.unitId != undefined){
//         query += query+` and rmi.plant_id=${req.unitId}`
//     }
        
// if (req.company) {
//     query += ` AND ucc.company='${req.company}'`
// }
    
// if(req.supplierId) {
//     query = query + ` AND (gi.farmer = '${req.supplierId}' OR gi.broker = '${req.supplierId}')`
// }
//     query = query+`  group by invoice_number`

//     const response = await manager.query(query)
//         if(response.length){
//             const totalDueAmount = response.reduce((sum, invoice) => {
//                 return sum + ((Number(invoice.invoiceAmt)-Number(invoice.paidAmount)) || 0);
//             }, 0);
//  const totalPaidAmount = response.reduce((sum, invoice) => {
//                 return sum + (Number(invoice.paidAmount) || 0);
//             }, 0);

//             // Create final response with both individual invoices and total sum
//             const finalResponse = {
//                 paidAmount:totalPaidAmount,
//                 dueAmount: (totalDueAmount) // Round to 2 decimal places
//             };
//             return new CommonResponse(true,1,'Data Retrived Sucessfully',[finalResponse])
//         }
//         else{
//             return new CommonResponse(false,0,'No Data Found',[])
//         }

//     }catch(err){
//         throw err
//     }
// }
async rmDueData(req: PayablesDashboardReq): Promise<CommonResponse> {
  try {
    console.log(req, 'request service');
    const manager = getManager();

    let query = `
      SELECT 
        SUM(rmi.total_amount - (gi.taxable_amount * 0.001)) AS invoiceAmt,
        SUM(rmi.total_amount) AS totalAmount,
        rmi.payment AS paidAmount,
        DATEDIFF('${req.toDate}', rmi.invoice_date) AS aging,
        rmi.invoice_number,
        rmi.invoice_date,
        gi.grn_item_id,
        rmi.indent_id,
        i.supplier_type AS supplierType,
        b.name AS brokerName,
        f.name AS farmerName,
        DATE_FORMAT(rmi.invoice_date, '%Y-%m-%d') AS invoice_date,
        SUM(gi.taxable_amount * 0.001) AS tdsval
      FROM erpx_dev_rm_procurement.rm_invoice rmi
      LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
      LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = rmi.grn_item_id
      LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
      LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.farmer = b.supplier_id AND i.supplier_type = 'Dealer'
      LEFT JOIN ${appSettings.masters_db}.unitcodes ucc ON ucc.company = gi.reweighment_bill_to AND ucc.plant_type = 'MANUFACTURING PLANT'
      WHERE rmi.invoice_date BETWEEN '${req.fromDate}' AND '${req.toDate}'
    `;

    if (req.unitId !== undefined) {
      query += ` AND rmi.plant_id = ${req.unitId}`;
    }

    if (req.company) {
      query += ` AND ucc.company = '${req.company}'`;
    }

    if (req.supplierId) {
      query += ` AND (gi.farmer = '${req.supplierId}' OR gi.broker = '${req.supplierId}')`;
    }

    query += ` GROUP BY rmi.invoice_number`;

    const response = await manager.query(query);

    if (response.length) {
      const totalDueAmount = response.reduce((sum, invoice) => {
        return sum + ((Number(invoice.invoiceAmt) - Number(invoice.paidAmount)) || 0);
      }, 0);

      const totalPaidAmount = response.reduce((sum, invoice) => {
        return sum + (Number(invoice.paidAmount) || 0);
      }, 0);

      const finalResponse = {
        paidAmount: totalPaidAmount,
        dueAmount: totalDueAmount
      };

      return new CommonResponse(true, 1, 'Data Retrieved Successfully', [finalResponse]);
    } else {
      return new CommonResponse(false, 0, 'No Data Found', []);
    }
  } catch (err) {
    throw err;
  }
}

async getCompanysForCeoDashboard():Promise<CommonResponse>{
    const manager=getManager()
    let query=`SELECT company_id AS companyId,company FROM ${appSettings.masters_db}.unitcodes GROUP BY company_id`
    const data=await manager.query(query)
    if(data.length>0){
        return new CommonResponse(true,1,"Companys Retrieved Successfully",data)
    }else{
        return new CommonResponse(false,0,"No Data Found",[])

    }
}
async getRmPayableInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
        // console.log(req,'ppppppppppppp');
        
        try{
 const manager = getManager();
//  const invoiceList = req.map(inv => `'${inv}'`).join(',');
    let query =`SELECT ri.grn_item_id AS invoiceId,ri.invoice_number AS invoiceNumber,ri.quantity,ri.unit_price AS unitPrice,total_amount ,ri.total_amount as amount,i.supplier_type AS type,f.name AS farmer, b.name AS dealer,ri.count AS count,
i.indent_code AS indentNumber,DATE_FORMAT(ri.invoice_date, '%Y-%m-%d') AS invoiceDate,(case when ri.type='GOOD' then gi.taxable_amount else 0 end)AS deduction,gi.tds_applicable AS tdsApplicable,ri.batch_number as batch,ri.payment,d.defect_name as deffect,ri.type as invoiceType ,CASE 
        WHEN i.supplier_type = 'Dealer' THEN b.supplier_id
        ELSE f.supplier_id
    END AS vendorId,CASE 
        WHEN i.supplier_type = 'Dealer' THEN b.name
        ELSE f.name
    END AS vendor
FROM ${appSettings.rm_procure_db}.rm_invoice ri 
LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = ri.grn_item_id
LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id
LEFT JOIN ${appSettings.masters_db}.suppliers f ON gi.farmer = f.supplier_id AND i.supplier_type != 'Dealer'
LEFT JOIN ${appSettings.masters_db}.suppliers b ON gi.broker = b.supplier_id AND i.supplier_type ='Dealer'
LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = ri.grn_id
left join ${appSettings.rm_procure_db}.grn_item_defects gid on ri.defect_id = gid.grn_item__defects_id and ri.type= 'DEFECT'
left join ${appSettings.masters_db}.defect d on d.defect_id= gid.defect_id
WHERE ri.payment_status !='${PayablePaymentStatusEnum.PAID}' `
if(req.invoiceNumber){
    query = query + ` and ri.invoice_number ='${req.invoiceNumber}'`
}

if(req.supplierId) {
    query = query + ` AND (gi.farmer = '${req.supplierId}' OR gi.broker = '${req.supplierId}')`
}
if(req.unit) {
    query = query + ` AND gi.reweighment_bill_to = '${req.unit}'`
}
    query= query + ` GROUP BY ri.rm_invoice_id`
    const data = await manager.query(query);
    console.log(data,'oooooooooooooo');

    if(data.length>0){
const invoiceMap = new Map();
  for (const item of data) {
                
                if (!invoiceMap.has(item.invoiceNumber)) {
                    invoiceMap.set(item.invoiceNumber, {
                        invoiceId: item.invoiceId,
                        invoiceNumber: item.invoiceNumber,
                        invoiceDate:item.invoiceDate,
                        type: item.type,
                        farmer: item.farmer,
                        dealer: item.dealer,
                        batch: item.batch,
                        indentNumber:item.indentNumber,
                        payment: Number(item.payment || 0),
            deduction:Number(item?.deduction || 0),
            vendorId:item.vendorId,
            vendor:item.vendor,
            quantity :Number(item.quantity || 0),
            amount : Number(item.amount || 0)
        });
    } else {
        const farmer = invoiceMap.get(item.invoiceNumber);
        console.log(farmer,'uuuuuuuuuuuuuuu');
        
        farmer.deduction += Number(item?.deduction || 0);
        farmer.quantity += Number(item?.quantity || 0);
        farmer.amount += Number(item?.amount || 0);
    }
              
            }
            
            // Convert map to array
            const result = Array.from(invoiceMap.values());
        return new CommonResponse(true,1,'Data retrieved successfully', result)
    }
   else{
        return new CommonResponse(false,0,' No Data Found')
   }

        }catch(err){
    throw (err);
}
    }
     async getPackingPayableInvoices(req:PayableFilterRequest):Promise<CommonResponse>{
        try{
            
 const manager = getManager();
    let query =`SELECT gi.grn_item_id AS invoiceId,gi.unit_price AS unitPrice,Sum(gi.received_quantity) AS quantity,sum(gi.tot_amount) AS amount,p.po_number AS poNumber,g.inv_no AS invoiceNumber,t.tax_percentage AS taxPer, sum(gi.tax_amount) AS taxAmount,sum(gi.taxable_amount) AS deduction,gi.tds_applicable AS tdsApplicable,DATE_FORMAT(g.invoice_date, '%Y-%m-%d') AS invoiceDate,ic.item_category AS itemCategory,isc.item_sub_category AS itemSubCategory, i.item_name AS item,v.vendor_name AS vendor,g.payment as paidAmount,sum(gi.discount_amount) as discount,gi.discount_per as discountPer,v.vendor_id as vendorId
FROM ${appSettings.procure_db}.grn_items gi 
LEFT JOIN ${appSettings.procure_db}.grn g ON g.grn_id = gi.grn_id
LEFT JOIN ${appSettings.procure_db}.purchase_order p ON p.purchase_order_id = gi.po_id
LEFT JOIN ${appSettings.masters_db}.vendors v ON g.vendor_id = v.vendor_id
LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = gi.tax_per
LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = gi.item_id
LEFT JOIN ${appSettings.masters_db}.item_categories ic ON ic.item_category_id = gi.item_category_id
LEFT JOIN ${appSettings.masters_db}.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
WHERE g.payment_status !='${PayablePaymentStatusEnum.PAID}' `
    if(req.invoiceNumber!= undefined){
        query = query + ` and g.inv_no ='${req.invoiceNumber}'`
    }
    if(req.supplierId) {
    query = query + ` AND g.vendor_id = '${req.supplierId}' `
}
   if(req.unit) {
    query = query + ` AND p.unit_id = '${req.unit}' `
    }

    query = query +` group by g.inv_no`
        const result = await manager.query(query);
 if(result.length>0){

        return new CommonResponse(true,1,'Data retrieved successfully', result)
    }
   else{
        return new CommonResponse(false,0,' No Data Found', result)
   }
        }catch(err){
    throw (err);
}
    }
    async getVendorRMTaxDataReport(req:AgingReq):Promise<CommonResponse>{
        try{
        const manager = getManager();
        // const finalDate = moment(req.toDate).format('YYYY-MM-DD');
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
        let invoiceQuery =`
         SELECT 
         CASE 
                    WHEN gi.broker = 0 THEN gi.farmer
                    WHEN gi.farmer = 0 THEN gi.broker
                    ELSE gi.broker
                END AS farmerId,
                CASE 
                    WHEN gi.broker = 0 THEN su.name
                    WHEN gi.farmer = 0 THEN s.name
                    ELSE s.name
                END AS farmerName,
                CASE 
                    WHEN gi.broker = 0 THEN su.pan_number
                    WHEN gi.farmer = 0 THEN s.pan_number
                    ELSE gi.broker
                END AS panNumber,rmi.invoice_number AS invNo,rmi.invoice_date AS invDate,i.supplier_type AS supplierType ,gi.tds_applicable AS tds,rmi.plant_id as unitId,uc.company as unitName,
            (gi.taxable_amount) AS taxableAmount,(rmi.total_amount) AS totalamount,((gi.taxable_amount)*(0.001)) AS tdsAmount,rmi.payment,
            DATEDIFF(DATE('${finalDate}'), DATE(rmi.invoice_date)) AS aging
            FROM ${appSettings.rm_procure_db}.rm_invoice rmi
            LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = rmi.indent_id
            LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id= rmi.grn_item_id
            LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.broker
            LEFT JOIN ${appSettings.masters_db}.suppliers su ON su.supplier_id =gi.farmer
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id =rmi.plant_id
            WHERE gi.tds_applicable = 1 and rmi.type='GOOD'
            `
            if (req.fromDate && req.toDate) {
            invoiceQuery += ` AND DATE(rmi.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
            }
            if(req.unitId){
            invoiceQuery += ` AND rmi.plant_id = ${req.unitId}`
              } 
            // invoiceQuery += ` GROUP BY  CASE 
            //         WHEN gi.broker = 0 THEN gi.farmer
            //         WHEN gi.farmer = 0 THEN gi.broker
            //         ELSE gi.broker
            //     END;`;
        const invoiceData = await manager.query(invoiceQuery);

        if (invoiceData.length > 0) {
            // Transform the data into the desired format
 const farmerMap = new Map();
  for (const item of invoiceData) {
                
                if (!farmerMap.has(item.farmerId)) {
                    farmerMap.set(item.farmerId, {
                        farmerId: item.farmerId,
                        farmerName: item.farmerName,
                        panNumber: item.panNumber,
                        taxableAmount: Number(item.taxableAmount || 0),
            tdsAmount: Number(item.tdsAmount || 0),
            totalAmount: Number(item.totalamount || 0),
            unitId:item.unitId,
            unitName:item.unitName
        });
    } else {
        const farmer = farmerMap.get(item.farmerId);
        farmer.taxableAmount += Number(item.taxableAmount || 0);
        farmer.tdsAmount += Number(item.tdsAmount || 0);
        farmer.totalAmount += Number(item.totalamount || 0);
    }
              
            }
            
            // Convert map to array
            const result = Array.from(farmerMap.values());
                 
    return new CommonResponse(true, 1, 'Data retrieved successfully', result);
  }else {
        return new CommonResponse(false, 0, 'No data found');
      }
        }catch(err){
        throw (err);
        }
        }
        async getVendorPackTaxDataReport(req: AgingReq): Promise<CommonResponse> {
    try {
        const manager = getManager();
        let finalDate = req.toDate!= undefined?moment(new Date()).format('YYYY-MM-DD'):moment(req.toDate).format('YYYY-MM-DD')
        let invoiceQuery = `
            SELECT g.vendor_id AS vendorId, g.inv_no AS invNo,g.invoice_date AS invDate,v.vendor_name AS vendorName,g.unit_id AS unitId,uc.unit_name AS unitName,uc.company,
                   SUM(gi.tot_amount) AS totalamount,
                   sum(gi.taxable_amount) AS taxableAmount,
                   sum(gi.taxable_amount *0.001) AS tdsAmount,
                   SUM((gi.received_quantity * gi.unit_price) * (COALESCE(t.tax_percentage, 0) / 100)) AS tax,
    (g.payment) AS payment,
                   DATEDIFF(DATE('${finalDate}'), DATE(g.invoice_date)) AS aging,v.pan_number as panNumber
            FROM ${appSettings.procure_db}.grn g
            LEFT JOIN ${appSettings.procure_db}.grn_items gi ON gi.grn_id = g.grn_id
            LEFT JOIN ${appSettings.masters_db}.taxes t ON t.tax_id = gi.tax_per
            LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = g.vendor_id
           LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=g.unit_id
            WHERE gi.tds_applicable = 1`;
        if (req.fromDate && req.toDate) {
            invoiceQuery += ` AND DATE(g.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
        }
        if (req.unitId) {
            invoiceQuery += ` AND g.unit_id = ${req.unitId}`;
        }
        if (req.vendorId) {
            invoiceQuery += ` AND g.vendor_id = ${req.vendorId}`;
        }

        invoiceQuery += ` GROUP BY g.vendor_id`;
        const invoiceData = await manager.query(invoiceQuery);
     

    if (invoiceData.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved successfully', invoiceData);
  }else {
        return new CommonResponse(false, 0, 'No data found');
      } } catch (err) {
                            throw err;
                        }
                    }

    async getRmInvoiceDataForPayables(req?: RmPayblesReq): Promise<CommonResponse> {
        console.log(req, 'request service');
    const manager = getManager();
    const statusCondition =
  req?.rmType === 'IMPORT PAYABLE' || req?.rmType === 'DOMESTIC'
    ? ` AND status = '${PayablePaymentStatusEnum.PAID}'`
    : '';

    
    

    let query=`SELECT
g.invoice_number AS invoiceNumber,
g.invoice_date AS invoiceDate,
gi.farmer AS vendorId,
SUM(gi.quantity) AS quantity,
SUM(gi.quantity*gi.price) AS invoiceAmount,
s.code,
i.rm_inward_type as inwardType,
s.name AS vendor
${
  req?.rmType === 'IMPORT PAYABLE' || req?.rmType === 'DOMESTIC'
    ? `,
(
    SELECT p1.status
    FROM ${appSettings.finance_db}.payables p1
    WHERE p1.invoice_number = g.invoice_number
      AND p1.rm_type = '${req?.rmType}'
    ORDER BY p1.id DESC
    LIMIT 1
) AS status,


(
SELECT
    IFNULL(SUM(p4.amount), 0)
FROM ${appSettings.finance_db}.payables p4
WHERE p4.invoice_number = g.invoice_number
AND p4.rm_type = '${req?.rmType}'
) AS paidAmount,

(
SELECT
CASE
    WHEN EXISTS (
        SELECT 1
        FROM ${appSettings.finance_db}.payables p3
        WHERE p3.invoice_number = g.invoice_number
        AND p3.rm_type = '${req?.rmType}'
    )
    THEN (
        SELECT MAX(p2.final_amount) - IFNULL(SUM(p2.amount), 0)
        FROM ${appSettings.finance_db}.payables p2
        WHERE p2.invoice_number = g.invoice_number
        AND p2.rm_type = '${req?.rmType}'
    )
    ELSE SUM(gi.quantity * gi.price)
END
) AS balanceAmount`
    : ''
}
    FROM ${appSettings.rm_procure_db}.grn g
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_id=g.grn_id
    LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = g.indent_no
    LEFT JOIN ${appSettings.masters_db}.suppliers s ON s.supplier_id = gi.farmer
    WHERE g.invoice_number IS NOT NULL AND i.rm_inward_type = '${
  req?.rmType === 'DOMESTIC' ? 'Domestic' : 'Import'
}' AND g.invoice_number NOT IN (
    SELECT p.invoice_number FROM ${appSettings.finance_db}.payables p WHERE rm_type='${req?.rmType}' ${statusCondition})
    GROUP BY g.invoice_number`

    const data = await manager.query(query);
    if (data.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved successfully', data);
    } else {
      return new CommonResponse(false, 0, 'No data found', null);
    }
} 

async getRmInvoiceDataForView(req: any): Promise<CommonResponse> {
  const manager = getManager();

  let query = `
    SELECT
      p.id,
      p.invoice_id,
      p.invoice_type AS invoiceType,
      p.invoice_number AS invoiceNumber,
      p.invoice_date as invoiceDate,
      p.received_date as receivedDate,
      p.status,
      p.vendor_id,
      p.quantity,
      p.amount AS invoiceAmount,
      p.deduction,
      p.final_amount AS finalAmount,
      p.payment,
      p.rm_type AS rmType,
      p.remarks,
      t.tax_name,
      t.tax_percentage,
      p.duty_per,

      CASE
        WHEN p.rm_type = 'IGST' THEN t.tax_percentage
        WHEN p.rm_type = 'DUTY PAID' THEN p.duty_per
        ELSE 0
      END AS applicablePercentage,

      CASE
        WHEN p.rm_type = 'IGST'
          THEN ROUND((p.final_amount * COALESCE(t.tax_percentage, 0)) / 100, 2)
        WHEN p.rm_type = 'DUTY PAID'
          THEN ROUND((p.final_amount * COALESCE(p.duty_per, 0)) / 100, 2)
        ELSE 0
      END AS taxAmount,
      s.name as vendorName

    FROM ${appSettings.finance_db}.payables p
    LEFT JOIN ${appSettings.masters_db}.taxes t
      ON t.tax_id = p.tax_id
    LEFT JOIN ${appSettings.masters_db}.suppliers s
      ON s.supplier_id = p.vendor_id
    WHERE p.invoice_type = 'RM'
  `;

  const params = [];

  if (req.rmType) {
    query += ` AND p.rm_type = ?`;
    params.push(req.rmType);
  }

  if (req.invoiceNumber) {
    query += ` AND p.invoice_number = ?`;
    params.push(req.invoiceNumber);
  }
  if (req.supplierId) {
  query += ` AND p.vendor_id = ?`;
  params.push(req.supplierId);
}

if (req.unit) {
  query += ` AND p.unit = ?`;
  params.push(req.unit);
}

if (req.invoiceFromDate && req.invoiceToDate) {
  query += ` AND DATE(p.invoice_date) BETWEEN ? AND ?`;
  params.push(req.invoiceFromDate, req.invoiceToDate);
}

if (req.receivedFromDate && req.receivedToDate) {
  query += ` AND DATE(p.received_date) BETWEEN ? AND ?`;
  params.push(req.receivedFromDate, req.receivedToDate);
}
  query += ` ORDER BY p.invoice_date DESC`;

  const data = await manager.query(query, params);

  if (data.length > 0) {
    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } else {
    return new CommonResponse(false, 0, 'No data found', []);
  }
}

}



